const adminSections = {
  // content: { key: 'content', name: '{{lang}}Content options', },

  // category: { key: 'category', name: 'Categories options', },
  // blog: { key: 'blog', name: 'blogs options', },
  // video: { key: 'video', name: 'videos options', },
  // podcast: { key: 'podcast', name: 'podcasts options', },
  // series: { key: 'series', name: 'series options', },
  // froum: { key: 'froum', name: '{{lang}}Froum options', },

  admin: { key: 'admin', name: '{{lang}}Admin options', },

  blogs: { key: 'blogs', name: 'Blogs Options', },
  shop: { key: 'shop', name: 'Shop Options', },

  // reports: { key: 'reports', name: 'Reports Options', },
  other: { key: 'other', name: 'Other Options', },


  // categories: { key: 'Countries', name: 'Countries options' },
  // product: { key: 'products', name: 'Products option' },
  // messages: { key: 'messages', name: 'messages option' }
}

const adminPages = {


  users: {
    key: 'users',
    title: 'کاربران',
    description: 'users list',
    fetchUrl: 'getUsers',
    // addUrl: 'addValue',
    editUrl: 'userUpdate',
    removeUrl: 'userRemove',
    options: { noAddNew: true },
    // helperKey: 'values',
    pageType: 'form',
    parent: 'admin',
    options: {},
    // sort: { 'cDate': -1 },
    addNew: -1,
    image: '/images/back1.jpg',
    // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    headers: [
      // { col: '6', key: 'username', type: 'TextInput', information: { label: 'نام کاربری', disabled: true, required: true }, showMain: true, inExport: true },
      // { col: '6', key: 'permissions', type: 'SelectInput', fullCol: true, information: { label: 'دسترسی ها', required: true, type: 'local', default: '0', items: [{ title: "Reserved", value: '0' }, { title: "Waiting For Delivery", value: '1' }, { title: 'In rental', value: '2' }, { title: 'Finished', value: '3', color: '#fff', backgroundColor: '#00CD74' }, { title: 'Cancelled By Requester', value: '10' }, { title: 'Cancelled By Ownner', value: '11' }] }, showMain: true, inExport: true },

      { col: '6', key: 'fullname', type: 'TextInput', information: { label: '{{lang}}Name', }, showMain: true, inExport: true },
      { col: '6', key: 'phone', type: 'TextInput', information: { label: '{{lang}}Phone number', }, showMain: true, inExport: true },
      { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

      {
        key: 'status',
        type: 'SelectInput',
        col: '6',
        information: {
          label: '{{lang}}Usertype',
          placeholder: '{{lang}}insert',
          type: 'local',
          items: [
            { title: "teacher", value: 'teachers' },
            { title: 'user', value: 'users' },
          ],
          required: true

        },
      },

      { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },
      // { col: '6', key: 'email', type: 'TextInput', information: { label: 'ایمیل' }, showMain: true, settings: { disabled: true }, hideInList: true },
    ],

  },
  baners: {
    key: 'baners',
    title: 'بنرها',
    description: 'Baners list',
    fetchUrl: 'getbaners',
    addUrl: 'postBaner',
    editUrl: 'postBaner',
    removeUrl: 'removebaner',
    options: { noAddNew: true },
    // helperKey: 'values',
    pageType: 'form',
    parent: 'admin',
    options: {},
    // sort: { 'cDate': -1 },
    // addNew: -1,
    image: '/images/back1.jpg',
    // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    headers: [
      // { col: '12', key: 'podcast', type: 'FileInput', information: { label: '{{lang}}podcast', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
      { col: '12', key: 'image', type: 'ImageInput', information: { label: '{{lang}}Image', single: true, cropper: false, placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
      { col: '12', key: 'mobileImage', type: 'ImageInput', information: { label: '{{lang}}mobileImage', single: true, cropper: false, placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
      { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', disabled: false, required: true }, showMain: true, inExport: true },
      // { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: true }, showMain: true },
      // { col: '12', key: 'courses', type: 'SelectInput', information: { label: '{{lang}}Series', updateAfterSelect: true, isSearchable: false, address: 'getCourses', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}series', required: false }, showMain: true },
      // { col: '12', key: 'audio', type: 'FileInput', information: { label: '{{lang}}صوت زمینه',  placeholder: '{{lang}}انتخاب فایل', required: false }, showMain: false },
      // { col: '6', key: 'teacher', type: 'MultiSelectInput', information: { label: '{{lang}}teacher', updateAfterSelect: true, isSearchable: true, required: true, address: 'getUsers', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}choose-teacher', required: false }, showMain: false },
      // { col: '12', key: 'slides', type: 'SlidesInput', information: { label: '{{lang}}Slides', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}slides', required: false }, showMain: false },
      // { col: '6', key: 'category', type: 'MultiSelectInput', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
      {
        key: 'pages',
        type: 'SelectInput',
        col: '6',
        information: {
          label: '{{lang}}Banerpage',
          placeholder: '{{lang}}insert',
          type: 'local',
          items: [
            { title: "homepage1", value: 'homepage1' },
            { title: 'homepage2', value: 'homepage2' },

          ],
          required: true

        },
      }
    ],

  },



  employees: {
    key: 'employee',
    title: 'کارمندان',
    description: 'Employees list',
    fetchUrl: 'employeeGetAll',
    addUrl: 'employeeAdd',
    editUrl: 'employeeAdd',
    removeUrl: 'employeeRemove',
    options: { noAddNew: true },
    // helperKey: 'values',
    pageType: 'form',
    parent: 'admin',
    options: {},
    // sort: { 'cDate': -1 },
    // addNew: -1,
    image: '/images/back1.jpg',
    // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    headers: [
      { col: '6', key: 'username', type: 'TextInput', information: { label: '{{lang}}Username', disabled: false, required: true }, showMain: true, inExport: true },
      { col: '6', key: 'fullname', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
      { col: '6', key: 'phone', type: 'TextInput', information: { label: '{{lang}}Phone number', disabled: false, required: true }, showMain: true, inExport: true },
      { col: '6', key: 'email', type: 'TextInput', information: { label: '{{lang}}Email', disabled: false, required: true }, showMain: true, inExport: true },
      { col: '6', key: 'password', type: 'TextInput', information: { label: '{{lang}}Password', disabled: false, required: true }, showMain: false, inExport: true },
    ],

  },
  // size: {
  //   key: 'size',
  //   title: 'سایز',
  //   description: 'sizes list',
  //   fetchUrl: 'getSizes',
  //   addUrl: 'postSize',
  //   editUrl: 'postSize',
  //   removeUrl: 'removeSize',
  //   options: { noAddNew: true },
  //   // helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'shop',
  //   options: {},
  //   // sort: { 'cDate': -1 },
  //   // addNew: -1,
  //   image: '/images/back1.jpg',
  //   // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //   headers: [
  //     { col: '6', key: 'size', type: 'TextInput', information: { label: '{{lang}}size', disabled: false, required: true }, showMain: true, inExport: true },
  //     { col: '6', key: 'description', type: 'TextInput', information: { label: '{{lang}}description', disabled: false, required: true }, showMain: true, inExport: true },
  //   ],

  // },


  categories: {
    key: 'categories',
    title: 'دسته بندی',
    description: 'Categories list',
    fetchUrl: 'getCategories',
    addUrl: 'categoryAdd',
    editUrl: 'categoryAdd',
    removeUrl: 'removeCategory',
    options: { noAddNew: true },
    // helperKey: 'values',
    pageType: 'form',
    parent: 'shop',
    options: {},
    // sort: { 'cDate': -1 },
    // addNew: -1,
    image: '/images/back1.jpg',
    // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    headers: [
      { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
      { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Persian Name', disabled: false, required: true }, showMain: true, inExport: true },
      { col: '6', key: 'enName', type: 'TextInput', information: { label: '{{lang}}English Name', disabled: false, required: false }, showMain: true, inExport: true },
      { col: '6', key: 'type', type: 'TextInput', information: { label: '{{lang}}Type', placeholder: 'factplast-products', disabled: false, required: false }, showMain: false, inExport: true },
      { col: '6', key: 'color', type: 'ColorInput', information: { label: '{{lang}}Color', disabled: false, required: false }, showMain: false, inExport: true },
      // { col: '6', type: 'MultiSelectInput', key: 'types', information: { label: '{{lang}}section', updateAfterSelect: true, isSearchable: false, address: 'getTypes', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertTypes', required: false }, showMain: false },
      // { col: '6', type: 'MultiSelectInput', key: 'series', information: { label: '{{lang}}series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertSeries', required: false }, showMain: false },
      // { col: '6', key: 'color', type: 'ColorInput', information: { label: '{{lang}}Color', disabled: false, required: true }, showMain: false, inExport: true },

      //   {
      //     type: 'SubformInput',
      //     key: 'specifications',
      //     col: '12',
      //     information: {
      //         label: '{{lang}}Specifications',
      //         headers: [
      //             { col: '6', type: 'MultiSelectInput', key: 'specification', information: { label: '{{lang}}Specification', updateAfterSelect: true, isSearchable: true, address: 'getAllSpecifications', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Specification', required: false }, showMain: false },
      //             { key: 'value', type: 'TextInput', col: '6', information: { label: '{{lang}}value', placeholder: '{{lang}}vlaue', required: false }, showMain: true },
      //         ],
      //         placeholder: '{{lang}}specifications',
      //         required: false,
      //     },
      //     showMain: false

      // },

      { col: '12', type: 'SelectInput', key: 'parent', information: { label: '{{lang}}parent', updateAfterSelect: true, isSearchable: true, address: 'getCategories', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
      { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false }, showMain: true },
    ],

  },

  Colors: {
    key: 'Colors',
    title: 'رنگ‌ها',
    description: 'Product colors list',
    fetchUrl: 'getColors',
    addUrl: 'postColor',
    editUrl: 'postColor',
    removeUrl: 'removeColor',
    pageType: 'form',
    parent: 'shop',
    options: {},
    sort: { priority: 1, cDate: -1 },
    image: '/images/back1.jpg',
    headers: [
      { key: 'title', type: 'TextInput', col: '6', information: { label: 'نام رنگ', placeholder: 'مثال: سفید', required: true }, showMain: true, inExport: true },
      { key: 'slug', type: 'TextInput', col: '6', information: { label: 'Slug', placeholder: 'white', required: false }, showMain: false, inExport: true },
      { key: 'hex', type: 'ColorInput', col: '6', information: { label: 'کد رنگ', placeholder: '#ffffff', required: true }, showMain: true, inExport: true },
      { key: 'textColor', type: 'ColorInput', col: '6', information: { label: 'رنگ متن', placeholder: '#111827', required: false }, showMain: false },
      { key: 'priority', type: 'NumberInput', col: '6', information: { label: 'ترتیب نمایش', placeholder: '1', required: false }, showMain: true, inExport: true },
      { key: 'active', type: 'SwitchInput', col: '6', information: { label: 'فعال', default: true, required: false }, showMain: true },
      { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false }, showMain: false },
    ],
  },

  Products: {
    key: 'Products',
    title: 'Products',
    description: 'Products list',
    fetchUrl: 'getProducts',
    addUrl: 'postProduct',
    editUrl: 'postProduct',
    removeUrl: 'removeProduct',
    modalWidth: 1100,
    // addNew: -1,

    // helperKey: 'values',
    pageType: 'form',
    parent: 'shop',

    options: {},
    sort: { uDate: -1, _id: -1 },
    image: '/images/back1.jpg',
    headers: [

      { key: 'cover', type: 'ImageInput', col: '12', information: { label: '{{lang}}cover', single: true, cropper: true, ratio: '5:5', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
      { key: 'images', type: 'ImageInput', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: '5:5', placeholder: '{{lang}}chooseImage', required: false }, showMain: false },
      { key: 'title', type: 'TextInput', col: '6', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true }, showMain: true },
      { key: 'slug', type: 'TextInput', col: '6', information: { label: '{{lang}}slug', placeholder: '{{lang}}slug', required: false }, showMain: false },
      { key: 'code', type: 'TextInput', col: '6', information: { label: 'کد محصول', placeholder: 'مثال: 101', required: false }, showMain: true, inExport: true },
      { key: 'sku', type: 'TextInput', col: '6', information: { label: 'SKU', placeholder: 'SKU / کد داخلی', required: false }, showMain: false, inExport: true },
      { key: 'inquiryOnly', type: 'SwitchInput', col: '6', information: { label: 'فقط استعلام قیمت', placeholder: 'برای استعلام قیمت تماس بگیرید', default: true, required: false }, showMain: true },
      { key: 'price', type: 'PriceInput', col: '6', information: { label: '{{lang}}Price', placeholder: 'فعلا خالی بماند', required: false }, showMain: false },
      { key: 'priceSttings.discount.value', type: 'PriceInput', col: '6', information: { label: '{{lang}}Discount (%)', hint: 'فعلا در سایت نمایش داده نمی‌شود', placeholder: '{{lang}}Discount', required: false }, showMain: false },
      { type: 'SelectInput', key: 'priceSttings.currency', col: '6', information: { label: '{{lang}}Currency', type: 'local', items: [{ value: 'IRT', title: 'تومان' }, { value: 'IRR', title: 'ریال' }], isSearchable: true, placeholder: '{{lang}}Currency', required: false }, showMain: false },
      { key: 'categories', col: 6, type: 'MultiLevelInput', information: { isSearchable: true, label: '{{lang}}categories', address: 'getCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: 'انتخاب دسته بندی', required: true }, showMain: true },

      // { type: 'SelectInput', key: 'categories', col: '6', information: { label: '{{lang}}categories', address: 'getCategories', fields: { title: 'name', value: '_id' },filter:{}, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
      // { type: 'SelectInput', key: 'brand', col: '6', information: { label: '{{lang}}brand', address: 'getBrands', fields: { title: 'name', value: '_id' },filter:{}, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
      // { col: '6', key: 'specifications', type: 'SelectInput', information: { label: '{{lang}}specifications', updateAfterSelect: true, isSearchable: true, address: 'getFilteredSpecifications', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}specifications', required: false }, showMain: false },

      // { type: 'MultiSelectInput', key: 'usecases', col: '6', information: { label: '{{lang}}usecases', address: 'getContents', filter: { page: 'Usecases' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}usecases', required: true }, showMain: false },
      { type: 'SelectInput', key: 'brand', col: '6', information: { label: '{{lang}}brand', address: 'getBrands', fields: { title: 'title', value: '_id' }, filter: {}, type: 'api', placeholder: '{{lang}}brand', required: false }, showMain: false },
      { key: 'family', type: 'TextInput', col: '6', information: { label: 'خانواده محصول', placeholder: 'مثال: پالت پلاستیکی', required: false }, showMain: true, inExport: true },
      { key: 'material', type: 'TextInput', col: '6', information: { label: 'جنس / متریال', placeholder: 'مثال: پلی اتیلن / پلی پروپیلن', required: false }, showMain: false, inExport: true },
      { key: 'applications', type: 'TagInput', col: '6', information: { hint: 'هر کاربرد را جدا وارد کنید', label: 'کاربردها', placeholder: 'انبارداری، حمل صنعتی، مواد غذایی', required: false }, showMain: false },
      { key: 'colors', type: 'MultiSelectInput', col: '6', information: { hint: 'رنگ‌های قابل تولید', label: 'رنگ‌ها', address: 'getColors', filter: { active: true }, fields: { title: 'title', value: 'title' }, type: 'api', isSearchable: true, placeholder: 'انتخاب رنگ‌های قابل تولید', required: false }, showMain: false },
      { key: 'tags', type: 'TagInput', col: '6', information: { hint: '{{lang}}tag-hint', label: '{{lang}}tags', placeholder: '{{lang}}insertTags', required: false }, showMain: false },
      { type: 'MultiSelectInput', key: 'special', col: '6', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'featured', title: 'Featured' }, { value: 'trending', title: 'trending' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: false },

      // { key: 'technologies', type: 'MultiSelectInput', col: '6', information: { label: '{{lang}}technology', default: '4', type: 'local', items: [{ value: 'Zigbee', title: 'Zigbee' }, { value: 'LoRa', title: 'LoRa' }, { value: 'Wifi', title: 'Wifi' }, { value: 'Bluetooth', title: 'Bluetooth' }, { value: 'Other', title: 'Other' }], placeholder: '{{lang}}select', required: true }, showMain: true },
      // { type: 'MultiSelectInput', key: 'lng', col: '6', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },
      // { type: 'MultiSelectInput', key: 'special', col: '6', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: true }, showMain: true },
      // { type: 'MultiSelectInput', key: 'special', col: '6', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }, { value: 'topSold', title: 'topSold' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
      // { key: 'tags', type: 'TagInput', col: '6', information: { hint: '{{lang}}tag-hint', label: '{{lang}}tags', placeholder: '{{lang}}insertTags', required: false }, showMain: false },
      // { key: 'partner', type: 'AdvancedSelectInput', col: "6", information: { label: '{{lang}}partner', address: 'getPartners', filter: {}, fields: { title: 'name', image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}partner', required: true }, showMain: false },
      { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
      { key: 'available', type: 'SwitchInput', col: "6", information: { label: '{{lang}}available', placeholder: '{{lang}}available', default: true, required: false }, showMain: true },
      { key: 'dimensions.length', type: 'NumberInput', col: '3', information: { label: 'طول', placeholder: 'cm', required: false }, showMain: false },
      { key: 'dimensions.width', type: 'NumberInput', col: '3', information: { label: 'عرض', placeholder: 'cm', required: false }, showMain: false },
      { key: 'dimensions.height', type: 'NumberInput', col: '3', information: { label: 'ارتفاع', placeholder: 'cm', required: false }, showMain: false },
      { key: 'dimensions.unit', type: 'TextInput', col: '3', information: { label: 'واحد ابعاد', placeholder: 'cm', required: false }, showMain: false },
      { key: 'dimensions.label', type: 'TextInput', col: '6', information: { label: 'ابعاد نمایشی', placeholder: '90 × 60 × 15', required: false }, showMain: true, inExport: true },
      { key: 'capacity.value', type: 'NumberInput', col: '3', information: { label: 'ظرفیت', placeholder: 'عدد', required: false }, showMain: false },
      { key: 'capacity.unit', type: 'TextInput', col: '3', information: { label: 'واحد ظرفیت', placeholder: 'لیتر / kg / ...', required: false }, showMain: false },
      { key: 'capacity.label', type: 'TextInput', col: '6', information: { label: 'ظرفیت نمایشی', placeholder: 'مثال: 500 لیتر', required: false }, showMain: false },
      { key: 'loadCapacity.staticKg', type: 'NumberInput', col: '4', information: { label: 'تحمل بار ثابت (kg)', placeholder: 'kg', required: false }, showMain: false },
      { key: 'loadCapacity.dynamicKg', type: 'NumberInput', col: '4', information: { label: 'تحمل بار متحرک (kg)', placeholder: 'kg', required: false }, showMain: false },
      { key: 'loadCapacity.rackKg', type: 'NumberInput', col: '4', information: { label: 'تحمل بار قفسه (kg)', placeholder: 'kg', required: false }, showMain: false },
      { key: 'weightKg', type: 'NumberInput', col: '6', information: { label: 'وزن (kg)', placeholder: 'kg', required: false }, showMain: false },
      // {
      //     key: 'slug',
      //     type: 'TextInput',
      //     col: '6',
      //     information: { label: '{{lang}}slug', placeholder: '{{lang}}slug', required: false },
      //     dependencies: [{
      //         refKey: '*',
      //         targetKey: 'slug',
      //         conditions: {
      //             root: {
      //                 id: 'root',
      //                 action: 'and',
      //                 conditions: {
      //                     1: { id: 1, source: { value: '@data._id' }, operator: { value: '!=' }, target: { value: null } }
      //                 }
      //             },
      //         },
      //         show: true,
      //         // changeHeader: { key: 'col:'6',information.filter.id', value: '@data.thing' },

      //     }],
      //     showMain: false
      // },


      {
        type: 'SubformInput',
        key: 'variants',
        information: {
          label: 'مدل‌ها / واریانت‌ها',
          headers: [
            { type: 'TextInput', key: 'code', col: '3', information: { label: 'کد', placeholder: 'کد مدل', required: false, disabled: false } },
            { type: 'TextInput', key: 'title', col: '3', information: { label: 'عنوان', placeholder: 'عنوان مدل', required: false } },
            { type: 'TextInput', key: 'dimensions', col: '3', information: { label: 'ابعاد', placeholder: 'ابعاد مدل', required: false } },
            { key: 'available', type: 'SwitchInput', col: "3", information: { label: '{{lang}}available', placeholder: '{{lang}}available', default: true, required: false }, showMain: true },

          ],
          placeholder: 'مدل‌ها',
          required: false
        },
        showMain: false
      },
      {
        type: 'SubformInput',
        key: 'specificationsList',
        col: '12',
        information: {
          label: '{{lang}}Specifications',
          headers: [
            { col: '4', type: 'SelectInput', key: 'key', information: { label: '{{lang}}Specification', updateAfterSelect: true, isSearchable: true, address: 'getAllSpecifications', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Specification', required: false }, showMain: false },
            { key: 'value', type: 'TextInput', col: '4', information: { label: '{{lang}}value', placeholder: '{{lang}}vlaue', required: false }, showMain: true },
            { key: 'featured', type: 'SwitchInput', col: "4", information: { label: '{{lang}}featured', placeholder: '{{lang}}featured', default: false, required: false }, showMain: false },

          ],
          placeholder: '{{lang}}specifications',
          required: false,
        },
        showMain: false

      },

      { key: 'seo.title', type: 'TextInput', col: '6', information: { label: 'SEO Title', placeholder: 'عنوان سئو', required: false }, showMain: false },
      { key: 'seo.description', type: 'TextAreaInput', col: '6', information: { label: 'SEO Description', placeholder: 'توضیحات سئو', required: false }, showMain: false },
      { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },
      { key: 'body', type: 'EditorInput', col: '12', information: { label: '{{lang}}body', placeholder: '{{lang}}body', required: false }, showMain: false },
    ]
  },
  Accounts: {
    key: 'Accounts',
    title: 'Accounts',
    description: 'Accounts list',
    fetchUrl: 'getAccounts',
    addUrl: 'postAccounts',
    editUrl: 'postAccounts',
    removeUrl: 'removeAccounts',
    modalWidth: 1100,
    // addNew: -1,

    // helperKey: 'values',
    pageType: 'form',
    parent: 'admin',

    options: {},
    sort: { 'cDate': -1 },
    image: '/images/back1.jpg',
    headers: [

      { type: 'DateInput', key: 'payDate', col: '6', information: { label: '{{lang}}Pay Date', type: 'local', isSearchable: true, placeholder: '{{lang}}Pay Date', required: false }, showMain: true, hideComponent: false },
      { type: 'DateInput', key: 'returnDate', col: '6', information: { label: '{{lang}}Return Date', type: 'local', isSearchable: true, placeholder: '{{lang}}Return Date', required: false }, showMain: true, hideComponent: false },
      { type: 'PriceInput', key: 'price',col: '6', information: { label: '{{lang}}Price', placeholder: '{{lang}}Price', required: true } },
      { type: 'SelectInput', key: 'partner', col: 6, information: { isSearchable: true, label: '{{lang}}partner', address: 'getPartners', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: null, reference: 'admin', placeholder: 'انتخاب فرد', required: true } },
      { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'payed' }, { value: '1', title: 'unpayed' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
      { type: 'SelectInput', key: 'AccountType', col: '6', information: { label: '{{lang}}Account Type', type: 'local', items: [{ value: '0', title: 'lend' }, { value: '1', title: 'borrow' }], isSearchable: true, placeholder: '{{lang}}Account Type', required: true }, showMain: true },

    ]
  },


  Partners: {
    key: 'Partners',
    title: 'Partners',
    description: 'Partners list',
    fetchUrl: 'getPartners',
    addUrl: 'postPartners',
    editUrl: 'postPartners',
    removeUrl: 'removePartners',
    modalWidth: 1100,
    // addNew: -1,

    // helperKey: 'values',
    pageType: 'form',
    parent: 'admin',

    options: {},
    // sort: { 'cDate': -1 },
    image: '/images/back1.jpg',
    headers: [

      { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
      { key: 'telephone', type: 'PhoneInput', col: '6', information: { label: '{{lang}}telephone', placeholder: '{{lang}}telephone', required: true } },
    ]
  },


  // survey: {
  //     key: 'survey',
  //     title: 'فرم های نظرسنجی',
  //     description: 'survey list',
  //     fetchUrl: 'getContents',
  //     // addUrl: 'postContent',
  //     removeUrl: 'removeContent',
  //     helperKey: 'values',
  //     pageType: 'form',
  //     parent: 'content',

  //     options: {},
  //     sort: { 'cDate': -1 },
  //     addNew: -1,
  //     image: '/images/back1.jpg',
  //     headers: [
  //         { key: 'values.name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', } },
  //         { key: 'values.surename', type: 'TextInput', col: '6', information: { label: '{{lang}}family'} },
  //         { key: 'values.email', type: 'EmailInput', col: '6', information: { label: '{{lang}}Email'} },
  //         { key: 'values.phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },
  //         { key: 'values.text', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description'} },
  //         { key: 'values.survey', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Survey'} },


  //     ]
  // },

  // complains: {
  //     key: 'complains',
  //     title: 'شکایات  ',
  //     description: 'complains list',
  //     fetchUrl: 'getContents',
  //     // addUrl: 'postContent',
  //     removeUrl: 'removeContent',
  //     helperKey: 'values',
  //     pageType: 'form',
  //     parent: 'content',

  //     options: {},
  //     sort: { 'cDate': -1 },
  //     addNew: -1,
  //     image: '/images/back1.jpg',
  //     headers: [
  //         { key: 'values.name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', } },
  //         { key: 'values.family', type: 'TextInput', col: '6', information: { label: '{{lang}}family'} },
  //         { key: 'values.email', type: 'EmailInput', col: '6', information: { label: '{{lang}}Email'} },
  //         { key: 'values.phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },
  //         { key: 'values.text', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description'} },


  //     ]
  // },
  // partnershipReq: {
  //     key: 'partnershipReq',
  //     title: ' درخواست نمایندگی فروش  ',
  //     description: 'partnershipReq list',
  //     fetchUrl: 'getContents',
  //     // addUrl: 'postContent',
  //     removeUrl: 'removeContent',
  //     helperKey: 'values',
  //     pageType: 'form',
  //     parent: 'content',

  //     options: {},
  //     sort: { 'cDate': -1 },
  //     addNew: -1,
  //     image: '/images/back1.jpg',
  //     headers: [
  //         { key: 'values.name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', } },
  //         { key: 'values.family', type: 'TextInput', col: '6', information: { label: '{{lang}}family'} },
  //         { key: 'values.sex', type: 'TextInput', col: '6', information: { label: '{{lang}}family'} },
  //         { key: 'values.id', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },
  //         { key: 'values.email', type: 'TextInput', col: '6', information: { label: '{{lang}}Email'} },
  //         { key: 'values.phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },
  //         { key: 'values.birthPlace', type: 'TextInput', col: '6', information: { label: '{{lang}}birthplace'} },
  //         { key: 'values.employeesCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },
  //         { key: 'values.totalExpereance', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },

  //         { key: 'values.stateType', type: 'TextInput', col: '6', information: { label: '{{lang}}birthplace'} },
  //         { key: 'values.stateMeterage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },

  //         { key: 'values.address', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description'} },
  //         { key: 'values.files', type: 'FileInput', col: '12', information: { label: '{{lang}}files'} },


  //     ]
  // },
  // partnershipRepairReq: {
  //     key: 'partnershipRepairReq',
  //     title: ' درخواست نمایندگی خدمات پس از فروش  ',
  //     description: 'partnershipRepairReq list',
  //     fetchUrl: 'getContents',
  //     // addUrl: 'postContent',
  //     removeUrl: 'removeContent',
  //     helperKey: 'values',
  //     pageType: 'form',
  //     parent: 'content',

  //     options: {},
  //     sort: { 'cDate': -1 },
  //     addNew: -1,
  //     image: '/images/back1.jpg',
  //     headers: [
  //         { key: 'values.name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', } },
  //         { key: 'values.family', type: 'TextInput', col: '6', information: { label: '{{lang}}family'} },
  //         { key: 'values.sex', type: 'TextInput', col: '6', information: { label: '{{lang}}family'} },
  //         { key: 'values.id', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },
  //         { key: 'values.birthPlace', type: 'TextInput', col: '6', information: { label: '{{lang}}birthplace'} },
  //         { key: 'values.employeesCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },
  //         { key: 'values.totalExpereance', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },

  //         { key: 'values.email', type: 'TextInput', col: '6', information: { label: '{{lang}}Email'} },
  //         { key: 'values.phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },
  //         { key: 'values.stateType', type: 'TextInput', col: '6', information: { label: '{{lang}}birthplace'} },
  //         { key: 'values.stateMeterage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },
  //         { key: 'values.address', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description'} },
  //         { key: 'values.files', type: 'FileInput', col: '12', information: { label: '{{lang}}files'} },


  //     ]
  // },
  // fallowRepairReq: {
  //     key: 'fallowRepairReq',
  //     title: ' درخواست پیگیری تعمیرات',
  //     description: 'fallowRepairReq list',
  //     fetchUrl: 'getContents',
  //     // addUrl: 'postContent',
  //     removeUrl: 'removeContent',
  //     helperKey: 'values',
  //     pageType: 'form',
  //     parent: 'content',

  //     options: {},
  //     sort: { 'cDate': -1 },
  //     addNew: -1,
  //     image: '/images/back1.jpg',
  //     headers: [
  //         { key: 'values.code', type: 'TextInput', col: '6', information: { label: 'کد تعمیرات', } },
  //         { key: 'values.id', type: 'NumberInput', col: '6', information: { label: 'کد ملی'} },
  //         { key: 'values.email', type: 'TextInput', col: '6', information: { label: '{{lang}}Email'} },
  //         { key: 'values.phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },


  //     ]
  // },
  // imeiRequest: {
  //     key: 'imeiRequest',
  //     title: ' درخواست imei ',
  //     description: 'imeiRequest list',
  //     fetchUrl: 'getContents',
  //     // addUrl: 'postContent',
  //     removeUrl: 'removeContent',
  //     helperKey: 'values',
  //     pageType: 'form',
  //     parent: 'content',

  //     options: {},
  //     sort: { 'cDate': -1 },
  //     addNew: -1,
  //     image: '/images/back1.jpg',
  //     headers: [
  //         { key: 'values.imei', type: 'NumberInput', col: '6', information: { label: '{{lang}}imei'} },
  //         { key: 'values.email', type: 'TextInput', col: '6', information: { label: '{{lang}}Email'} },
  //         { key: 'values.phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone'} },


  //     ]
  // },





  // partners: {
  //     key: 'partners',
  //     title: 'Partners',
  //     description: 'Partners list',
  //     fetchUrl: 'getPartners',
  //     addUrl: 'postPartner',
  //     editUrl: 'postPartner',

  //     removeUrl: 'removePartner',
  //     helperKey: 'values',
  //     pageType: 'form',
  //     parent: 'shop',
  //     options: {},
  //     sort: { 'cDate': -1 },
  //     // addNew: -1,
  //     image: '/images/back1.jpg',
  //     // extra: { export: { url: 'usersExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //     headers: [

  //         { type: 'TextInput', key: 'name', col: "6", information: { label: '{{lang}}Shop name', placeholder: '{{lang}}name', required: true } },

  //         { key: 'user', type: 'AdvancedSelectInput', col: "6", information: { label: '{{lang}}User', address: 'getUsers', filter: {}, fields: { title: 'phone', description: "fullname", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },

  //         { type: 'TextInput', key: 'phone', col: "6", information: { label: '{{lang}}phone', placeholder: '{{lang}}phone', required: true }, showMain: false },
  //         { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },

  //         // { type: 'MultiSelectInput', key: 'lng', col: '12', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },
  //         { type: 'TextInput', key: 'address', information: { label: '{{lang}}address', placeholder: '{{lang}}address', required: true }, showMain: false },

  //         { type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: false } },
  //         { type: 'FileInput', key: 'file', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: false } },

  //         // { type: 'SelectInput', key: 'country', information: { label: "Country", type: 'local', items: [{ title: "USA", value: "USA" }, { title: "Iran", value: "Iran" }, { title: "United Kingdom", value: "United Kingdom" }, { title: "Germany", value: "Germany" }, { title: "United Arab Emirates", value: "United Arab Emirates" }], }, },

  //         { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false }, showMain: false },

  //         { key: 'reqdescription', type: 'TextAreaInput', information: { label: '{{lang}}Request Description', placeholder: '{{lang}}description', required: false }, showMain: false },

  //         // { type: 'FileInput', key: 'attachments', col: '12', information: { label: '{{lang}}attachments', single: false, accept: 'image/*,.pdf,.zip,.doc,.docx', placeholder: '{{lang}}attachments', required: false }, showMain: false },

  //         // { key: 'verified', type: 'SwitchInput',  information: { label: '{{lang}}active', placeholder: '{{lang}}inactive', default: true, required: false } },

  //         // { type: 'NumberInput', key: 'activationCode', information: { label: '{{lang}}activationCode', placeholder: '{{lang}}activationCode', required: false }, showMain: true },



  //     ]
  // },




  orders: {
    key: 'orders',
    title: 'orders',
    description: 'Orders list',
    fetchUrl: 'getOrders',
    addUrl: 'postOrder',
    editUrl: 'postOrder',

    removeUrl: 'removeOrder',
    helperKey: 'values',
    pageType: 'form',
    parent: 'shop',
    options: {},
    sort: { 'cDate': -1 },
    postBody: { proccessfinalized: true },

    // addNew: -1,
    image: '/images/back1.jpg',
    // extra: { export: { url: 'usersExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    headers: [

      { key: 'user', type: 'AdvancedSelectInput', col: "12", information: { label: '{{lang}}User', address: 'getUsers', filter: {}, fields: { title: 'phone', description: "fullname", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },
      { type: 'TextInput', key: 'id', col: '6', information: { label: '{{lang}}id', placeholder: '{{lang}}Id', required: false, disabled: true }, showMain: true, hideComponent: true },

      {
        type: 'SubformInput',
        key: 'list',
        information: {
          label: '{{lang}}texts.thing.characterestics',
          headers: [
            { key: 'product', type: 'AdvancedSelectInput', col: "4", information: { label: '{{lang}}Product', address: 'getProducts', filter: {}, fields: { title: 'title', image: 'images', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Product', required: true }, showMain: true },
            { type: 'PriceInput', key: 'price', col: '4', information: { label: '{{lang}}Price', placeholder: '{{lang}}Price', required: true } },
            { type: 'NumberInput', key: 'count', col: '4', information: { label: '{{lang}}Count', placeholder: '{{lang}}Count', required: true } },
            // { key: 'partner', type: 'AdvancedSelectInput', col: "4", information: { label: '{{lang}}partner', address: 'getPartners', filter: {}, fields: { title: 'name', image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}partner', required: true }, showMain: true },
          ],
          // removeDisabled: true,
          // addDisabled: true,
          // hint: "{{lang}}decriptionAboutCharacteristics",
          placeholder: '{{lang}}items list',
          required: true
        },
        showMain: false
      },

      { type: 'PriceInput', key: 'totalPrice', col: "6", information: { label: '{{lang}}Total Price', placeholder: '{{lang}}name', required: false }, hideComponent: true },

      { type: 'PriceInput', key: 'deliveryPrice', col: '6', information: { label: '{{lang}}Delivery Price', placeholder: '{{lang}}Delivery Price', required: true } },
      { type: 'PriceInput', key: 'extraDiscount', col: '6', information: { label: '{{lang}}Extra Discount', placeholder: '{{lang}}Extra Discount', required: true } },

      // { type: 'PhoneInput', key: 'phone', col: "6", information: { label: '{{lang}}phone', placeholder: '{{lang}}phone', required: true }, showMain: false },
      // { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },

      // { type: 'MultiSelectInput', key: 'lng', col: '12', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },


      { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'Confirmed' }, { value: '2', title: 'Finished' }, { value: '-1', title: 'Canceled' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
      { type: 'SelectInput', key: 'paymentStatus', col: '6', information: { label: '{{lang}}Payment Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '2', title: 'Finished' }, { value: '-1', title: 'Canceled' }], isSearchable: true, placeholder: '{{lang}}Payment Status', required: true }, showMain: true },
      { type: 'SelectInput', key: 'transactionStatus', col: '6', information: { label: '{{lang}}Transaction Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '2', title: 'Finished' }, { value: '-1', title: 'Canceled' }], isSearchable: true, placeholder: '{{lang}}Transaction Status', required: true }, showMain: true },


      { type: 'SectionInput', key: '*address', information: { label: '{{lang}}address' }, showMain: false },

      { type: 'TextInput', key: 'address.province', col: '6', information: { label: '{{lang}}province / state', placeholder: '{{lang}}province / state', required: true }, showMain: false },
      { type: 'TextInput', key: 'address.city', col: '6', information: { label: '{{lang}}city', placeholder: '{{lang}}city', required: true }, showMain: false },
      { type: 'TextInput', key: 'address.address', information: { label: '{{lang}}address', placeholder: '{{lang}}address', required: true }, showMain: false },
      { type: 'MapLeafletInput', key: 'address.location', information: { label: '{{lang}}location', placeholder: '{{lang}}location', required: false, disabled: true }, showMain: false },

      { type: 'SectionInput', key: '*recepient', information: { label: '{{lang}}recepient' }, showMain: false },
      { type: 'TextInput', key: 'recipient.name', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true }, showMain: false },
      { type: 'TextInput', key: 'recipient.family', col: '6', information: { label: '{{lang}}family', placeholder: '{{lang}}family', required: true }, showMain: false },

      { type: 'NumberInput', key: 'recipient.phone', col: '6', information: { label: '{{lang}}phone', placeholder: '{{lang}}phone', required: true }, showMain: false },
      // { type: 'TextInput', key: 'recepient.nationalId', col: '6', information: { label: '{{lang}}National Id', pattern: '[0-9]*', maxLength: 10, placeholder: '{{lang}}National Id', required: false }, showMain: false },


      { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false }, showMain: false },
      { key: 'remark', type: 'TextAreaInput', information: { label: '{{lang}}remark', placeholder: '{{lang}}remark', required: false }, showMain: false },
    ]
  },

  invoices: {
    key: 'invoices',
    title: '{{lang}}Invoices',
    description: '{{lang}}Create and print invoices for online and in-person sales',
    pageType: 'invoice',
    parent: 'shop',
    addUrl: 'postOrder',
    image: '/images/back1.jpg',
    fetchUrl: 'getOrders',
    sort: { 'cDate': -1 },
    postBody: {},
  },

  changePrice: {
    key: 'changePrice',
    title: '{{lang}}Change Price',
    description: 'Bulk update product prices by percentage',
    pageType: 'changePrice',
    parent: 'shop',
    submitUrl: 'changeProductPrices',
    image: '/images/back1.jpg',
    headers: [
      { key: 'percentage', type: 'NumberInput', col: '12', information: { label: '{{lang}}Percentage', placeholder: '{{lang}}Percentage', hint: 'Positive to increase, negative to decrease', required: true }, showMain: true },
      { key: 'category', type: 'SelectInput', col: '4', information: { label: '{{lang}}Category', address: 'getCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Category', required: false }, showMain: true },
      { key: 'supplier', type: 'SelectInput', col: '4', information: { label: '{{lang}}Supplier', address: 'getPartners', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Supplier', required: false }, showMain: true },
      { key: 'brand', type: 'SelectInput', col: '4', information: { label: '{{lang}}Brand', address: 'getBrands', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Brand', required: false }, showMain: true },
    ],
  },

  // addresses: {
  //   key: 'addresses',
  //   title: 'Addresses',
  //   description: 'Addresses list',
  //   fetchUrl: 'getAddresses',
  //   addUrl: 'postAddress',
  //   editUrl: 'postAddress',

  //   removeUrl: 'removeAddress',
  //   helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'shop',
  //   options: {},
  //   sort: { 'cDate': -1 },
  //   // addNew: -1,
  //   image: '/images/back1.jpg',
  //   // extra: { export: { url: 'usersExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //   headers: [

  //       { key: 'user', type: 'AdvancedSelectInput', col: "12", information: { label: '{{lang}}User', address: 'getUsers', filter: {}, fields: { title: 'phone', description: "fullname", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },

  //       { type: 'TextInput', key: 'province', col: '6', information: { label: '{{lang}}province / state', placeholder: '{{lang}}province / state', required: true }, showMain: true },
  //       { type: 'TextInput', key: 'city', col: '6', information: { label: '{{lang}}city', placeholder: '{{lang}}city', required: true }, showMain: true },
  //       { type: 'TextInput', key: 'address', information: { label: '{{lang}}address', placeholder: '{{lang}}address', required: true }, showMain: false },
  //       { type: 'TextInput', key: 'zipCode', information: { label: "Zip Code", placeholder: "Zip Code", required: true, } },

  //       { type: 'MapLeafletInput', key: 'location', information: { label: '{{lang}}location', placeholder: '{{lang}}location', required: false, disabled: true }, showMain: false },

  //       { type: 'TextInput', key: 'recipient.name', information: { label: "recipient name", placeholder: "Name", required: true, }, },
  //       { type: 'TextInput', key: 'recipient.family', information: { label: "Recipient family", placeholder: "Family", required: true, }, },
  //       { type: 'TextInput', key: 'recipient.phone', information: { label: "Recipient phone", placeholder: "phone", required: true, }, },


  //       // { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false }, showMain: false },
  //   ]
  // },





  // shopPayments: {
  //   key: 'shopPayments',
  //   title: 'Payments',
  //   description: 'Shop Payments list',
  //   fetchUrl: 'getShopPayments',
  //   addUrl: 'postShopPayment',
  //   editUrl: 'postShopPayment',

  //   removeUrl: 'removeShopPayment',
  //   helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'shop',
  //   options: {},
  //   sort: { 'cDate': -1 },
  //   // addNew: -1,
  //   image: '/images/back1.jpg',
  //   postBody: { proccessfinalized: true },

  //   // extra: { export: { url: 'usersExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //   headers: [

  //       { key: 'user', type: 'AdvancedSelectInput', col: "6", information: { label: '{{lang}}User', address: 'getUsers', filter: {}, fields: { title: 'phone', description: "fullname", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },
  //       { type: 'TextInput', key: 'id', col: '6', information: { label: '{{lang}}id', placeholder: '{{lang}}Id', required: false, disabled: true }, showMain: true, hideComponent: true },

  //       { key: 'order', type: 'AdvancedSelectInput', col: "6", information: { label: '{{lang}}Order', address: 'getOrders', filter: {}, fields: { title: 'id', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Order', required: true }, showMain: true },

  //       { type: 'DateInput', key: 'cDate', col: '6', information: { label: '{{lang}}Create Date', type: 'local', isSearchable: true, placeholder: '{{lang}}Create Date', required: false }, showMain: true, hideComponent: true },

  //       { type: 'PriceInput', key: 'amount', col: '6', information: { label: '{{lang}}amount', placeholder: '{{lang}}amount', required: true }, showMain: true },

  //       { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: 'Not Checked', title: 'Not Checked' }, { value: 'Checked', title: 'Checked' }, { value: 'Rejected', title: 'Rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
  //       { type: 'SelectInput', key: 'method', col: '6', information: { label: '{{lang}}method', type: 'local', items: [{ value: 'cash', title: 'cash' }, { value: 'online', title: 'online' }, { value: 'credit', title: 'credit' }], isSearchable: true, placeholder: '{{lang}}method', required: true }, showMain: false },

  //       { type: 'TextInput', key: 'refId', col: '6', information: { label: '{{lang}}refId', placeholder: '{{lang}}refId', required: false }, showMain: false },
  //       { type: 'TextInput', key: 'authority', col: '6', information: { label: '{{lang}}authority', placeholder: '{{lang}}authority', required: false }, showMain: false },


  //       { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false }, showMain: false },
  //   ]
  // },










  ///////// Blogs




  Blogs: {
    key: 'Blogs',
    title: 'Blogs',
    description: 'Blogs list',
    fetchUrl: 'getBlogs',
    addUrl: 'postBlog',
    editUrl: 'postBlog',
    removeUrl: 'removeBlog',
    modalWidth: 1100,

    // helperKey: 'values',
    pageType: 'form',
    parent: 'blogs',

    options: {},
    sort: { 'cDate': -1 },
    image: '/images/back1.jpg',
    headers: [

      { key: 'title', type: 'TextInput', col: '6', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
      { type: 'MultiSelectInput', key: 'categories', col: '6', information: { label: '{{lang}}categories', address: 'getContents', filter: { page: 'BlogsCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },

      { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '5:3', placeholder: '{{lang}}chooseImage', required: true } },

      // { type: 'MultiSelectInput', key: 'lng', col: '6', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },

      {
        key: 'slug',
        type: 'TextInput',
        col: '6',
        information: { label: '{{lang}}slug', placeholder: '{{lang}}slug', required: false },
        dependencies: [{
          refKey: '*',
          targetKey: 'slug',
          conditions: {
            root: {
              id: 'root',
              action: 'and',
              conditions: {
                1: { id: 1, source: { value: '@data._id' }, operator: { value: '!=' }, target: { value: null } }
              }
            },
          },
          show: true,
          // changeHeader: { key: 'col:'6',information.filter.id', value: '@data.thing' },

        }],
        showMain: true
      },
      { type: 'MultiSelectInput', key: 'special', col: '6', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },

      // { key: 'tags', type: 'TagInput', col: '6', information: { hint: '{{lang}}tag-hint', label: '{{lang}}tags', placeholder: '{{lang}}insertTags', required: false }, showMain: false },
      // { type: 'SelectInput', key: 'teacher', col: '6', information: { label: '{{lang}}Writer', address: 'getContents', filter: { page: 'Teachers' }, fields: { title: 'values.name', value: '_id' }, type: 'api', isSearchable: true, required: false }, showMain: false },

      { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },
      { key: 'body', type: 'EditorInput', col: '12', information: { label: '{{lang}}body', placeholder: '{{lang}}body', required: false }, showMain: false },
    ]
  },
  Brands: {
    key: 'Brands',
    title: 'Brands',
    description: 'Brands list',
    fetchUrl: 'getBrands',
    addUrl: 'postBrand',
    editUrl: 'postBrand',
    removeUrl: 'removeBrand',
    modalWidth: 1100,

    // helperKey: 'values',
    pageType: 'form',
    parent: 'shop',

    options: {},
    sort: { 'cDate': -1 },
    image: '/images/back1.jpg',
    headers: [

      { key: 'title', type: 'TextInput', col: '6', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
      // { type: 'SelectInput', key: 'categories', col: '6', information: { label: '{{lang}}categories', address: 'getCategories', fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: true }, showMain: false },
      { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, placeholder: '{{lang}}chooseImage', required: true } },
      // { col: '6', key: 'color', type: 'ColorInput', information: { label: '{{lang}}Color', disabled: false, required: true }, showMain: false, inExport: true },
      // { col: '6', type: 'MultiSelectInput', key: 'categories', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: true, address: 'getCategories', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
      // { key: 'categories', col: 6, type: 'MultiLevelInput', information: { isSearchable: true, label: '{{lang}}categories', address: 'getCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: 'انتخاب دسته بندی', required: true } },

      // { type: 'MultiSelectInput', key: 'lng', col: '6', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },

      {
        key: 'slug',
        type: 'TextInput',
        col: '6',
        information: { label: '{{lang}}slug', placeholder: '{{lang}}slug', required: false },
        dependencies: [{
          refKey: '*',
          targetKey: 'slug',
          conditions: {
            root: {
              id: 'root',
              action: 'and',
              conditions: {
                1: { id: 1, source: { value: '@data._id' }, operator: { value: '!=' }, target: { value: null } }
              }
            },
          },
          show: true,
          // changeHeader: { key: 'col:'6',information.filter.id', value: '@data.thing' },

        }],
        showMain: true
      },

      { type: 'MultiSelectInput', key: 'special', col: '6', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },

      // { key: 'tags', type: 'TagInput', col: '6', information: { hint: '{{lang}}tag-hint', label: '{{lang}}tags', placeholder: '{{lang}}insertTags', required: false }, showMain: false },
      // { type: 'SelectInput', key: 'teacher', col: '6', information: { label: '{{lang}}Writer', address: 'getContents', filter: { page: 'Teachers' }, fields: { title: 'values.name', value: '_id' }, type: 'api', isSearchable: true, required: false }, showMain: false },

      { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: true }, showMain: false },
      { key: 'body', type: 'EditorInput', col: '12', information: { label: '{{lang}}body', placeholder: '{{lang}}body', required: false }, showMain: false },
    ]
  },

  specifications: {
    key: 'specifications',
    title: 'Specifications',
    description: 'Specifications list',
    fetchUrl: 'getAllSpecifications',
    addUrl: 'addSpecifications',
    editUrl: 'addSpecifications',
    removeUrl: 'RemoveSpecifications',
    options: { noAddNew: true },
    // helperKey: 'values',
    pageType: 'form',
    parent: 'shop',
    options: {},
    // sort: { 'cDate': -1 },
    // addNew: -1,
    image: '/images/covers/11.jpg',
    extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    headers: [
      { col: '6', key: 'title', type: 'TextInput', information: { label: 'Title', disabled: false, required: true }, showMain: true, inExport: true },
      { col: '6', key: 'en.title', type: 'TextInput', information: { label: 'English Title', disabled: false, required: false }, showMain: false, inExport: true },
      { col: '6', key: 'type', type: 'TextInput', information: { label: '{{lang}}Type', placeholder: 'factplast-products', disabled: false, required: false }, showMain: false, inExport: true },
      // { key: 'type', type: 'SelectInput', col: '6', information: { label: '{{lang}}Type', placeholder: '{{lang}}select type', type: 'local', items: [{ title: "Number", value: 'Number' }, { title: "select", value: 'select' }, { title: "Text", value: 'text' }] }, showMain: true },
      { col: '6', type: 'MultiSelectInput', key: 'categories', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: true, address: 'getCategories', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
      { col: '6', key: 'sufix', type: 'TextInput', information: { label: '{{lang}}Sufix', placeholder: '{{lang}}sufix', required: false }, showMain: true },
      { col: '6', key: 'min', type: 'NumberInput', information: { label: '{{lang}}min', placeholder: '{{lang}}min', required: false }, showMain: false },
      { col: '6', key: 'max', type: 'NumberInput', information: { label: '{{lang}}max', placeholder: '{{lang}}max', required: false }, showMain: false },

      // {
      //     type: 'SubformInput',
      //     key: 'options',
      //     title: 'Options',
      //     col: '12',
      //     information: {
      //         headers: [
      //             { col: '6', key: 'label', type: 'TextInput', information: { label: '{{lang}}label', placeholder: '{{lang}}label', required: true }, showMain: true },
      //             { col: '6', key: 'en.label', type: 'TextInput', information: { label: '{{lang}}English label', placeholder: '{{lang}}English label', required: false }, showMain: true },

      //             // { col: '8', key: 'label', type: 'SelectInput', information: { label: '{{lang}}label', updateAfterSelect: true, isSearchable: true, address: 'getSizes', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}chose sizes', required: true }, showMain: false },
      //             // { col: '8', key: 'sizes', type: 'MultiSelectInput', information: { label: '{{lang}}sizes', updateAfterSelect: true, isSearchable: true, address: 'getSizes', filter: { page: 'form' }, fields: { title: 'sizes[0].size', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}chose sizes', required: true }, showMain: false },
      //         ],
      //         placeholder: '{{lang}}Options',
      //         required: true,
      //         showMain: false
      //     }
      // },
      // { col: '12', key: 'values', type: 'TagInput', information: { label: '{{lang}}values', placeholder: '{{lang}}values', required: false }, showMain: false },
      // { col: '6', type: 'SelectInput', key: 'parent', information: { label: '{{lang}}parent', updateAfterSelect: true, isSearchable: true, address: 'getAllSpecifications', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
      { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false }, showMain: false },

    ],

  },



  // BlogsCategories: {
  //   key: 'BlogsCategories',
  //   title: 'Blogs Categories',
  //   description: 'Blogs Categories list',
  //   fetchUrl: 'getContents',
  //   addUrl: 'postContent',
  //   removeUrl: 'removeContent',
  //   helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'blogs',

  //   options: {},
  //   sort: { 'cDate': -1 },
  //   image: '/images/back1.jpg',
  //   headers: [
  //       { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true } },
  //       { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
  //       { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },

  //   ]
  // },










  /////// Other


  // Usecases: {
  //   key: 'Usecases',
  //   title: 'Use Cases',
  //   description: 'Usecases list',
  //   fetchUrl: 'getContents',
  //   addUrl: 'postContent',
  //   removeUrl: 'removeContent',
  //   helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'other',
  //   modalWidth: 1100,
  //   options: {},
  //   sort: { 'cDate': -1 },
  //   image: '/images/back1.jpg',
  //   headers: [
  //       { key: 'values.title', type: 'TextInput', col: '6', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
  //       { type: 'MultiSelectInput', key: 'values.lng', col: '6', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },
  //       { key: 'values.icon', type: 'ImageInput', col: '12', information: { label: '{{lang}}icon', single: true, cropper: true, placeholder: '{{lang}}chooseImage', required: true } },

  //       { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '5:3', placeholder: '{{lang}}chooseImage', required: true } },
  //       // { key: 'values.color1', type: 'TextInput', col: '6', information: { label: '{{lang}}color1', placeholder: '{{lang}}color1', required: true }, showMain: false },
  //       // { key: 'values.color2', type: 'TextInput', col: '6', information: { label: '{{lang}}color2', placeholder: '{{lang}}color2', required: true }, showMain: false },
  //       { key: 'values.description', type: 'TextAreaInput', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: true }, showMain: false },
  //       { key: 'values.body', type: 'EditorInput', information: { label: '{{lang}}body', placeholder: '{{lang}}body', required: true }, showMain: false },

  //   ]
  // },




  // dynamicPages: {
  //   key: 'dynamicPages',
  //   title: 'Dynamic Pages',
  //   description: 'Dynamic Pages list',
  //   fetchUrl: 'getContents',
  //   addUrl: 'postContent',
  //   removeUrl: 'removeContent',
  //   helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'other',

  //   options: {},
  //   sort: { 'cDate': -1 },
  //   image: '/images/back1.jpg',
  //   headers: [
  //       // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, placeholder: '{{lang}}chooseImage', required: true } },
  //       { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
  //       { key: 'values.slug', type: 'TextInput', information: { label: '{{lang}}slug', placeholder: '{{lang}}slug', required: true } },

  //       { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },

  //       { key: 'values.description', type: 'TextAreaInput', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: true } },
  //       { key: 'values.body', type: 'EditorInput', information: { label: '{{lang}}body', placeholder: '{{lang}}body', required: true }, showMain: false },
  //   ]
  // },



  FAQ: {
    key: 'FAQ',
    title: 'FAQ',
    description: 'FAQ list',
    fetchUrl: 'getContents',
    addUrl: 'postContent',
    removeUrl: 'removeContent',
    helperKey: 'values',
    pageType: 'form',
    parent: 'other',

    options: {},
    sort: { 'values.priority': -1 },
    image: '/images/back1.jpg',
    headers: [
      { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
      // { type: 'SelectInput', key: 'values.parent', col: '12', information: { label: '{{lang}}parent', address: 'getContents', filter: { page: 'DocumentsCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: false },
      { key: 'values.description', type: 'TextAreaInput', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: true }, showMain: false },
      { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: false } },

      { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },

    ]
  },


  Requests: {
    key: 'Requests',
    title: 'Requests',
    description: 'Requests list',
    fetchUrl: 'getContents',
    addUrl: 'postContent',
    removeUrl: 'removeContent',
    helperKey: 'values',
    pageType: 'form',
    parent: 'other',

    options: {},
    sort: {},
    image: '/images/back1.jpg',
    headers: [
      { type: 'TextInput', key: 'values.name', information: { label: "نام", placeholder: "نام ", required: true }, },
      { type: 'TextInput', key: 'values.family', information: { label: "نام خانوادگی", placeholder: "نام خانوادگی", required: true }, },

      // { type: 'FileInput', key: 'values.file', col: '12', information: { label: '{{lang}}Additional-file', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}Upload your logo', required: false } },

      { type: 'TextInput', key: 'values.email', information: { label: "ایمیل", placeholder: "ایمیل", required: false }, },
      { type: 'TextInput', key: 'values.Phone', information: { label: "شماره تماس", placeholder: "شماره تماس", required: true }, },
      // { type: 'TextInput', key: 'values.website', information: { label: "{{lang}}Company Website", placeholder: "{{lang}}Website", }, },

      // { type: 'SelectInput', key: 'values.country', information: { label: "{{lang}}Country", type: 'local', items: [{ title: "USA", value: "USA" }, { title: "Iran", value: "Iran" }, { title: "United Kingdom", value: "United Kingdom" }, { title: "Germany", value: "Germany" }, { title: "United Arab Emirates", value: "United Arab Emirates" }], }, },
      { type: 'TextInput', key: 'values.city', information: { label: "شهر", placeholder: "شهر", type: 'local', items: [{ title: "1-99", value: "1-99" }, { title: "100-999", value: "100-999" }, { title: "1000-4999", value: "1000-4999" }, { title: "5000+", value: "5000+" }], }, },
      { type: 'TextAreaInput', key: 'values.address', information: { label: "آدرس", placeholder: "آدرس", }, },

      // { type: 'TextAreaInput', key: 'values.peyment', information: { label: "Title", items: [{ title: "1-99", value: "maryam" }, { title: "100-999", value: "pouya" }, { title: "1000-4999", value: "pedram" }, { title: "5000+", value: "pedram" }], }, },
      { type: 'TextAreaInput', key: 'values.other', information: { rows: 10, label: "توضیحات", placeholder: "توضیحات تکمیلی", required: true }, },
      { type: 'FileInput', key: 'values.file', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },
      { type: 'ImageInput', key: 'values.image', col: '12', information: { label: 'آپلود عکس', cropper: true, ratio: '1:1', placeholder: '', required: false } },
    ]
  },

  importRequests: {
    key: 'imports',
    title: 'Import Requests',
    description: 'Import Requests list',
    fetchUrl: 'getContents',
    addUrl: 'postContent',
    removeUrl: 'removeContent',
    helperKey: 'values',
    pageType: 'form',
    parent: 'other',

    options: {},
    sort: {},
    image: '/images/back1.jpg',
    headers: [
      { type: 'TextInput', key: 'values.name', information: { label: "نام", placeholder: "نام ", required: true }, },
      { type: 'TextInput', key: 'values.family', information: { label: "نام خانوادگی", placeholder: "نام خانوادگی", required: true }, },

      // { type: 'FileInput', key: 'values.file', col: '12', information: { label: '{{lang}}Additional-file', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}Upload your logo', required: false } },

      { type: 'TextInput', key: 'values.email', information: { label: "ایمیل", placeholder: "ایمیل", required: false }, },
      { type: 'TextInput', key: 'values.Phone', information: { label: "شماره تماس", placeholder: "شماره تماس", required: true }, },
      // { type: 'TextInput', key: 'values.website', information: { label: "{{lang}}Company Website", placeholder: "{{lang}}Website", }, },

      // { type: 'SelectInput', key: 'values.country', information: { label: "{{lang}}Country", type: 'local', items: [{ title: "USA", value: "USA" }, { title: "Iran", value: "Iran" }, { title: "United Kingdom", value: "United Kingdom" }, { title: "Germany", value: "Germany" }, { title: "United Arab Emirates", value: "United Arab Emirates" }], }, },
      { type: 'TextInput', key: 'values.city', information: { label: "شهر", placeholder: "شهر", type: 'local', items: [{ title: "1-99", value: "1-99" }, { title: "100-999", value: "100-999" }, { title: "1000-4999", value: "1000-4999" }, { title: "5000+", value: "5000+" }], }, },
      { type: 'TextAreaInput', key: 'values.address', information: { label: "آدرس", placeholder: "آدرس", }, },

      // { type: 'TextAreaInput', key: 'values.peyment', information: { label: "Title", items: [{ title: "1-99", value: "maryam" }, { title: "100-999", value: "pouya" }, { title: "1000-4999", value: "pedram" }, { title: "5000+", value: "pedram" }], }, },
      { type: 'TextAreaInput', key: 'values.other', information: { rows: 10, label: "توضیحات", placeholder: "توضیحات تکمیلی", required: true }, },
      { type: 'FileInput', key: 'values.file', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },
      { type: 'ImageInput', key: 'values.image', col: '12', information: { label: 'آپلود عکس', cropper: true, ratio: '1:1', placeholder: '', required: false } },
    ]
  },




  // advertisements: {
  //   key: 'advertisements',
  //   title: 'Advertisements',
  //   description: 'Advertisements list',
  //   fetchUrl: 'getContents',
  //   addUrl: 'postContent',
  //   removeUrl: 'removeContent',
  //   helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'other',

  //   options: {},
  //   sort: { 'cDate': -1 },
  //   image: '/images/back1.jpg',
  //   headers: [
  //       { key: 'values.title', type: 'TextInput', col: '6', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },

  //       { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, placeholder: '{{lang}}chooseImage', required: true } },
  //       { key: 'values.address', type: 'TextInput', col: '6', information: { label: '{{lang}}address', placeholder: '{{lang}}address', required: false }, showMain: false },
  //       { key: 'values.pages', type: 'MultiSelectInput', col: '6', information: { label: '{{lang}}pages', type: 'local', items: [{ value: 'shop-main', title: 'shop-main' }, { value: 'shop-featured_1', title: 'shop-featured_1' }, { value: 'shop-featured_2', title: 'shop-featured_2' }, { value: 'shop-featured_3', title: 'shop-featured_3' }, { value: 'shop-featured_4', title: 'shop-featured_4' }, { value: 'shop-list', title: 'shop-list' }, { value: 'single_blog', title: 'Single Blog' }, { value: 'forum-main', title: 'Forum Main' }, { value: 'forum-question', title: 'Forum Question' }], placeholder: '{{lang}}select', required: true }, showMain: true },
  //       { key: 'values.active', type: 'SwitchInput', col: '6', information: { label: '{{lang}}active', placeholder: '{{lang}}inactive', default: true, required: false } },
  //       // { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },

  //       { key: 'values.description', type: 'TextAreaInput', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },
  //   ]
  // },


  permissions: {
    key: 'permissions',
    title: 'permissions',
    description: 'permissions List',
    fetchUrl: 'getPermissions',
    removeUrl: 'removePermission',
    // editUrl: 'addValue',
    // removeUrl: 'removeValue',
    pageType: 'form',
    page: 'permissions',
    parent: 'admin',
    image: '/images/covers/dashboards.jpg',
    addNew: '/admin/permission',
    hideFilter: true,

    headers: [
      // { key: 'groups', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}useful.groups', placeholder: '{{lang}}useful.groups', required: false, disabled: true }, showMain: true },
      { key: 'users', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}Users', fields: { title: 'username', value: '_id' }, placeholder: '{{lang}}useful.users', required: false, disabled: true, showAllInTable: true }, showMain: true },

      { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false, disabled: true }, showMain: true },


    ]
  },


  permission: {
    key: 'permission',
    title: 'permission',
    description: 'permission List',
    fetchUrl: 'getPermission',
    addUrl: 'addPermission',
    editUrl: 'addPermission',
    // removeUrl: 'removePermission',
    pageType: 'permissions',
    page: 'permissions',
    permissionRules: ['admin.permissions.create', 'admin.permissions.edit'],
    permissionParent: 'permissions',
    // parent: 'admin',
    image: '/images/covers/dashboards.jpg',

    headers: [
      { type: 'TextInput', key: 'email', information: { label: 'Email', }, showMain: true },
      { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "unsubscribed", value: '0' }, { title: 'active', value: '1' }] }, settings: { required: false }, showMain: true },


    ]
  },

  // blogs: {
  //     key: 'blogs',
  //     title: 'blogs',
  //     description: 'blogs list',
  //     fetchUrl: 'getBlogs',
  //     addUrl: 'postBlog',
  //     editUrl: 'postBlog',
  //     removeUrl: 'removeBlogs',
  //     options: { noAddNew: true },
  //     // helperKey: 'values',
  //     pageType: 'form',
  //     parent: 'content',
  //     options: {},
  //     // sort: { 'cDate': -1 },
  //     // addNew: -1,
  //     image: '/images/covers/11.jpg',
  //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //     headers: [
  //         { col: '12', key: 'image', type: 'ImageInput', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
  //         { col: '6', key: 'title', type: 'TextInput', information: { label: 'title', disabled: false, required: true }, showMain: true, inExport: true },
  //         { col: '6', key: 'categories', type: 'MultiSelectInput', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
  //         { col: '4', key: 'tags', type: 'TagInput', information: { hint: '{{lang}}tag-hint', label: '{{lang}}tags', placeholder: '{{lang}}insertTags', required: false }, showMain: false },
  //         { col: '4', key: 'lng', type: 'TagInput', information: { hint: '{{lang}}tag-hint', label: '{{lang}}lng', placeholder: '{{lang}}insertTags', required: false }, showMain: false },
  //         { col: '4', key: 'special', type: 'TagInput', information: { hint: '{{lang}}tag-hint', label: '{{lang}}special', placeholder: '{{lang}}insertTags', required: false }, showMain: false },
  //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
  //         { col: '12', key: 'body', type: 'TextAreaInput', information: { label: '{{lang}}content', placeholder: '{{lang}}content', required: true }, showMain: false },
  //     ],

  // },

  // videos: {
  //     key: 'videos',
  //     title: 'videos',
  //     description: 'videos list',
  //     fetchUrl: 'getVideos',
  //     addUrl: 'postVideo',
  //     editUrl: 'postVideo',
  //     removeUrl: 'removeVideo',
  //     options: { noAddNew: true },
  //     // helperKey: 'values',
  //     pageType: 'form',
  //     parent: 'content',
  //     options: {},
  //     // sort: { 'cDate': -1 },
  //     // addNew: -1,
  //     image: '/images/covers/11.jpg',
  //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //     headers: [
  //         { col: '12', key: 'video', type: 'FileInput', information: { label: '{{lang}}video', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
  //         { col: '12', key: 'title', type: 'TextInput', information: { label: 'title', disabled: false, required: true }, showMain: true, inExport: true },
  //         { col: '12', key: 'thumbnail', type: 'ImageInput', information: { label: '{{lang}}thumbnail', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
  //         { col: '6', key: 'series', type: 'MultiSelectInput', information: { label: '{{lang}}series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertSeries', required: false }, showMain: false },
  //         { col: '6', key: 'category', type: 'MultiSelectInput', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
  //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
  //     ],

  // },


  // // series: {
  // //     key: 'series',
  // //     title: '{{lang}}Series',
  // //     description: 'series list',
  // //     fetchUrl: 'getSeries',
  // //     addUrl: 'postSeries',
  // //     editUrl: 'postSeries',
  // //     removeUrl: 'removeSeries',
  // //     options: { noAddNew: true },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'content',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/11.jpg',
  // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { col: '12', key: 'thumbnail', type: 'ImageInput', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '5:3', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
  // //         { col: '12', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
  // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
  // //         { col: '6', type: 'MultiSelectInput', key: 'special', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'suggestion', title: 'Suggestion' }, { value: 'special', title: 'Special' }], isSearchable: true, placeholder: '{{lang}}special', required: true }, showMain: true },
  // //         // { col: '6', key: 'type', type: 'SelectInput', col: '6', information: { label: '{{lang}}podcast type', placeholder: '{{lang}}insert', type: 'local', items: [{ title: "podcast", value: 'podcast' }, { title: 'video', value: 'video' }, { title: 'text', value: 'text' },], required: true }, showMain: true },
  // //         { col: '6', key: 'category', type: 'SelectInput', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
  // //         { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}body', placeholder: '{{lang}}body', required: true }, showMain: false },
  // //     ],

  // // },

  // courses: {
  //   key: 'courses',
  //   title: 'دوره ها',
  //   description: 'Courses list',
  //   fetchUrl: 'getCourses',
  //   addUrl: 'postCourse',
  //   editUrl: 'postCourse',
  //   removeUrl: 'removeCourse',
  //   options: { noAddNew: true },
  //   // helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'content',
  //   options: {},
  //   // sort: { 'cDate': -1 },
  //   // addNew: -1,
  //   image: '/images/back1.jpg',
  //   // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //   headers: [
  //     // { col: '12', key: 'podcast', type: 'FileInput', information: { label: '{{lang}}podcast', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
  //     { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', disabled: false, required: true }, showMain: true, inExport: true },
  //     { col: '12', key: 'image', type: 'ImageInput', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '5:3', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
  //     { col: '12', key: 'categories', type: 'MultiSelectInput', information: { label: '{{lang}}categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}categories', required: false }, showMain: true },
  //     // { col: '12', key: 'level', type: 'SelectInput', information: { label: '{{lang}}Series', updateAfterSelect: true, isSearchable: false, address: 'getCourses', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}series', required: false }, showMain: true },
  //     {
  //       col: '6', key: 'level', type: 'SelectInput', information: {
  //         label: '{{lang}}level', type: 'local',
  //         items:
  //           [{ value: 'basic', title: '{{lang}}basic' },
  //           { value: 'intermediate', title: '{{lang}}intermediate' },
  //           { value: 'advance', title: '{{lang}}advance' }],
  //         isSearchable: true, placeholder: '{{lang}}level', required: true
  //       }, showMain: true
  //     },
  //     { col: '6', key: 'price', type: 'NumberInput', information: { label: '{{lang}}price', placeholder: '{{lang}}price', required: true }, showMain: true },


  //     { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
  //     { col: '12', key: 'audiance', type: 'TextAreaInput', information: { label: '{{lang}}audiance', placeholder: '{{lang}}audiance', required: false }, showMain: false },
  //     { col: '12', key: 'achievements', type: 'TextAreaInput', information: { label: '{{lang}}achievements', placeholder: '{{lang}}achievements', required: false }, showMain: false },
  //     // { col: '12', key: 'series', type: 'MultiSelectInput', information: { label: '{{lang}}Series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}series', required: false }, showMain: true },
  //     // { col: '12', key: 'audio', type: 'FileInput', information: { label: '{{lang}}صوت زمینه',  placeholder: '{{lang}}انتخاب فایل', required: false }, showMain: false },

  //     // { col: '12', key: 'slides', type: 'SlidesInput', information: { label: '{{lang}}Slides', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}slides', required: false }, showMain: false },
  //     { col: '6', key: 'teacher', type: 'MultiSelectInput', information: { label: '{{lang}}teacher', updateAfterSelect: true, isSearchable: true, required: true, address: 'teachersGetAll', filter: { page: 'form' }, fields: { title: 'fullname', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}choose-teacher', required: false }, showMain: true },
  //     { col: '6', key: 'books', type: 'NumberInput', information: { label: '{{lang}}book', placeholder: '{{lang}}book', required: false, required: false }, showMain: true },
  //   ],

  // },
  // lessons: {
  //   key: 'lessons',
  //   title: 'اسنک ها',
  //   description: 'Lessons list',
  //   fetchUrl: 'getLessons',
  //   addUrl: 'postLesson',
  //   editUrl: 'postLesson',
  //   removeUrl: 'removeLesson',
  //   options: { noAddNew: true },
  //   // helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'content',
  //   options: {},
  //   // sort: { 'cDate': -1 },
  //   // addNew: -1,
  //   image: '/images/back1.jpg',
  //   // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //   headers: [
  //     // { col: '12', key: 'podcast', type: 'FileInput', information: { label: '{{lang}}podcast', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
  //     { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', disabled: false, required: true }, showMain: true, inExport: true },
  //     { col: '12', key: 'image', type: 'ImageInput', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '5:3', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
  //     { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
  //     { col: '12', key: 'course', type: 'SelectInput', information: { label: '{{lang}}Series', updateAfterSelect: true, isSearchable: false, address: 'getCourses', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}series', required: false }, showMain: true },
  //     // { col: '12', key: 'audio', type: 'FileInput', information: { label: '{{lang}}صوت زمینه',  placeholder: '{{lang}}انتخاب فایل', required: false }, showMain: false },
  //     { col: '6', key: 'teacher', type: 'MultiSelectInput', information: { label: '{{lang}}teacher', updateAfterSelect: true, isSearchable: true, required: true, address: 'getUsers', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}choose-teacher', required: false }, showMain: true },
  //     // { col: '12', key: 'video', type: 'VideoInput', information: { label: '{{lang}}video', placeholder: '{{lang}}video', required: false }, showMain: false },
  //     { col: '12', key: 'video', type: 'FileInput', information: { label: '{{lang}}video', placeholder: '{{lang}}video', single: true, required: false }, showMain: false },

  //     // { col: '12', key: 'slides', type: 'SlidesInput', information: { label: '{{lang}}Slides', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}slides', required: false }, showMain: false },
  //     // { col: '6', key: 'category', type: 'MultiSelectInput', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
  //   ],

  // },


  // // ForumsCategories: {
  // //     key: 'ForumsCategories',
  // //     title: '{{lang}}Forum Categories',
  // //     description: 'categories list',
  // //     fetchUrl: 'getContents',
  // //     addUrl: 'postContent',
  // //     removeUrl: 'removeContent',
  // //     options: { noAddNew: true },
  // //     pageType: 'form',
  // //     parent: 'froum',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/16.jpeg',
  // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },


  // //     headers: [
  // //         { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
  // //         { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
  // //         { key: 'values.description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: true }, showMain: true },
  // //         { key: 'values.priority', type: 'NumberInput', information: { label: '{{lang}}Priority', placeholder: '{{lang}}Priority', required: false }, showMain: true },
  // //         // { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },
  // //     ],

  // // },


  // // questions: {
  // //     key: 'froum',
  // //     title: '{{lang}}Questions',
  // //     description: 'questions list',
  // //     fetchUrl: 'getQuestions',
  // //     addUrl: 'postQuestion',
  // //     editUrl: 'postQuestion',
  // //     removeUrl: 'removeQuestion',
  // //     options: { noAddNew: false },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'froum',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/8.jpg',
  // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { col: '6', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true },showMain:true },
  // //         { col: '6', key: 'status', type: 'SelectInput', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
  // //         { col: '6', key: 'category', type: 'SelectInput', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: false, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
  // //         // { col: '6', key: 'votes', type: 'NumberInput', information: { label: '{{lang}}Votes', placeholder: '{{lang}}votes', required: false }, hideComponent: true, showMain: false },
  // //         { col: '6', key: 'answers', type: 'NumberInput', information: { label: '{{lang}}Answers', placeholder: '{{lang}}answers', required: false }, hideComponent: true, showMain:true},
  // //         // { col: '6', key: 'views', type: 'NumberInput', information: { label: '{{lang}}views', placeholder: '{{lang}}views', required: false }, hideComponent: true, showMain: false },
  // //         { col: '6', type: 'MultiSelectInput', key: 'special', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
  // //         // { col: '6', key: 'major', type: 'SelectInput', col: '6', information: { label: '{{lang}}رشته ها', placeholder: '{{lang}}insert', type: 'local', items: [{ title: "ریاضی", value: 'ریاضی' }, { title: 'تجربی', value: 'تجربی' }, { title: 'انسانی', value: 'انسانی' },], required: true }, showMain: true },
  // //         // { col: '6', key: 'grade', type: 'SelectInput', information: { label: '{{lang}}مقطع تحصیلی', placeholder: '{{lang}}insert', type: 'local', items: [{ title: "دهم", value: 'دهم' }, { title: 'یازدهم', value: 'یازدهم' }, { title: 'دوازدهم', value: 'دوازدهم' },], required: true }, showMain: false },
  // //         { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}Body', placeholder: '{{lang}}body', required: true }, showMain: false },
  // //     ],

  // // },

  // Practices: {
  //   key: 'practices',
  //   title: 'تمارین',
  //   description: 'practices list',
  //   fetchUrl: 'getPractices',
  //   addUrl: 'postPractice',
  //   editUrl: 'postPractice',
  //   removeUrl: 'removePractice',
  //   options: { noAddNew: false },
  //   // helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'content',
  //   options: {},
  //   // sort: { 'cDate': -1 },
  //   // addNew: -1,
  //   image: '/images/back1.jpg',
  //   // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //   headers: [
  //     { col: '6', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
  //     // { col: '6', key: 'status', type: 'SelectInput', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
  //     { col: '6', key: 'lesson', type: 'SelectInput', information: { label: '{{lang}}Lesson', updateAfterSelect: true, isSearchable: false, address: 'getLessons', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}insertlessons', required: false }, showMain: true },
  //     // { col: '6', key: 'views', type: 'NumberInput', information: { label: '{{lang}}views', placeholder: '{{lang}}views', required: false }, hideComponent: true, showMain: false },
  //     // { col: '6', type: 'MultiSelectInput', key: 'special', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
  //     // { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}Body', placeholder: '{{lang}}body', required: true }, showMain: false },
  //     { col: '12', key: 'files', type: 'FileInput', information: { label: '{{lang}}files', placeholder: '{{lang}}files', required: false }, showMain: false },
  //   ],

  // },
  // courseFiles: {
  //   key: 'courseFiles',
  //   title: 'فایل های دوره',
  //   description: 'courseFiles list',
  //   fetchUrl: 'getCourseFiles',
  //   addUrl: 'postCourseFile',
  //   editUrl: 'postCourseFile',
  //   removeUrl: 'removeCourseFile',
  //   options: { noAddNew: false },
  //   // helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'content',
  //   options: {},
  //   // sort: { 'cDate': -1 },
  //   // addNew: -1,
  //   image: '/images/back1.jpg',
  //   // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //   headers: [
  //     { col: '12', key: 'image', type: 'ImageInput', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
  //     { col: '6', key: 'title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}Title', required: true }, showMain: true },
  //     { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
  //     // { col: '6', key: 'status', type: 'SelectInput', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
  //     { col: '6', key: 'course', type: 'SelectInput', information: { label: '{{lang}}course', updateAfterSelect: true, isSearchable: false, address: 'getCourses', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}insertlessons', required: false }, showMain: true },
  //     // { col: '6', key: 'views', type: 'NumberInput', information: { label: '{{lang}}views', placeholder: '{{lang}}views', required: false }, hideComponent: true, showMain: false },
  //     // { col: '6', type: 'MultiSelectInput', key: 'special', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
  //     // { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}Body', placeholder: '{{lang}}body', required: true }, showMain: false },
  //     { col: '12', key: 'files', type: 'FileInput', information: { label: '{{lang}}files', placeholder: '{{lang}}files', required: false }, showMain: false },

  //   ],

  // },

  // quizes: {
  //   key: 'quizes',
  //   title: 'آزمون ها',
  //   description: 'quizes list',
  //   fetchUrl: 'getQuizes',
  //   addUrl: 'postQuiz',
  //   editUrl: 'postQuiz',
  //   removeUrl: 'removeQuiz',
  //   options: { noAddNew: false },
  //   // helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'content',
  //   options: {},
  //   // sort: { 'cDate': -1 },
  //   // addNew: -1,
  //   image: '/images/back1.jpg',
  //   // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //   headers: [
  //     { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}Title', required: true }, showMain: true },
  //     { col: '12', key: 'image', type: 'ImageInput', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
  //     { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
  //     { col: '6', key: 'level', type: 'SelectInput', information: { label: '{{lang}}level', type: 'local', items: [{ value: 'easy', title: '{{lang}}easy' }, { value: 'intermediate', title: '{{lang}}intermediate' }, { value: 'hard', title: '{{lang}}hard' }], placeholder: '{{lang}}level', required: true }, showMain: true },
  //     { col: '6', key: 'course', type: 'SelectInput', information: { label: '{{lang}}course', updateAfterSelect: true, isSearchable: false, address: 'getCourses', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}insertcourse', required: false }, showMain: true },
  //     { col: '6', key: 'time', type: 'NumberInput', information: { label: '{{lang}}time(minutes)', placeholder: '{{lang}}time', required: false, required: true }, showMain: true },
  //     // { col: '6', type: 'MultiSelectInput', key: 'special', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
  //     // { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}Body', placeholder: '{{lang}}body', required: true }, showMain: false },
  //     // { col: '12', key:'files', type:'FileInput', information: { label: '{{lang}}files', placeholder: '{{lang}}files', required: false },showMain: false },

  //   ],

  // },

  // questions: {
  //   key: 'questions',
  //   title: 'سوال ها',
  //   description: 'questions list',
  //   fetchUrl: 'getQuestions',
  //   addUrl: 'postQuestion',
  //   editUrl: 'postQuestion',
  //   removeUrl: 'removeQuestion',
  //   options: { noAddNew: true },
  //   // helperKey: 'values',
  //   pageType: 'form',
  //   parent: 'content',
  //   options: {},
  //   // sort: { 'cDate': -1 },
  //   // addNew: -1,
  //   image: '/images/back1.jpg',
  //   // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  //   headers: [
  //     { col: '6', key: 'title', type: 'TextAreaInput', information: { label: '{{lang}}Title', disabled: false, required: true }, showMain: true, inExport: true },
  //     { col: '12', key: 'image', type: 'ImageInput', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

  //     { col: '6', type: 'SelectInput', key: 'quiz', information: { label: '{{lang}}quiz', updateAfterSelect: true, isSearchable: true, address: 'getQuizes', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: true }, showMain: true },
  //     //    { col: '12', type: 'SelectInput', key: 'specifications', information: { label: '{{lang}}specifications', updateAfterSelect: true, isSearchable: true, address: 'getAllSpecifications', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}specifications', required: false }, showMain: false },
  //     {
  //       type: 'SubformInput',
  //       key: 'answers',
  //       col: '12',
  //       information: {
  //         headers: [
  //           { type: 'TextInput', key: 'answer', col: '6', information: { label: '{{lang}}Answer', placeholder: '{{lang}}Answer', required: true }, showMain: true, },
  //           { type: 'NumberInput', key: 'score', col: '6', information: { label: '{{lang}}score', placeholder: '{{lang}}score', required: true }, showMain: true, },
  //         ],

  //         placeholder: '{{lang}}answers',
  //         required: true,
  //       },
  //       showMain: true
  //     },

  //   ],

  // },


  // // dynamicPages: {
  // //     key: 'dynamicPages',
  // //     title: 'Dynamic Pages',
  // //     description: 'Dynamic Pages list',
  // //     fetchUrl: 'getContents',
  // //     addUrl: 'postContent',
  // //     removeUrl: 'removeContent',
  // //     helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'content',

  // //     options: {},
  // //     sort: { 'cDate': -1 },
  // //     image: '/images/back1.jpg',
  // //     headers: [
  // //         // { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, placeholder: '{{lang}}chooseImage', required: true } },
  // //         { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
  // //         { key: 'values.slug', type: 'TextInput', information: { label: '{{lang}}slug', placeholder: '{{lang}}slug', required: true } },

  // //         { type: 'MultiSelectInput', key: 'values.lng', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },

  // //         { key: 'values.description', type: 'TextAreaInput', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: true } },
  // //         { key: 'values.body', type: 'EditorInput', information: { label: '{{lang}}body', placeholder: '{{lang}}body', required: true }, showMain: false },
  // //     ]
  // // },



  // // answers: {
  // //     key: 'froum2',
  // //     title: '{{lang}}Answers',
  // //     description: 'answers list',
  // //     fetchUrl: 'getAnswers',
  // //     addUrl: 'postAnswer',
  // //     removeUrl: 'removeAnswer',
  // //     // options: { noAddNew: true },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'froum',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/7.jpg',
  // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         // { key: 'question', type: 'TextInput', col: '6', information: { label: '{{lang}}question', placeholder: '{{lang}}question', disabled: false, required: true }, disabled: true, },
  // //         { type: 'SelectInput', key: 'question', col: '6', information: { label: '{{lang}}Question', updateAfterSelect: true, isSearchable: true, address: 'getQuestions', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.questions', required: false }, showMain: true },
  // //         { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
  // //         { key: 'body', type: 'EditorInput', col: '12', information: { label: '{{lang}}Body', placeholder: '{{lang}}Body', required: true }, showMain: true },
  // //         // { key: 'votes', type: 'NumberInput', col: '6', information: { label: '{{lang}}votes', placeholder: '{{lang}}Votes', required: false }, hideComponent: true, disabled: true, showMain: true },
  // //     ],

  // // },


  // // specifications: {
  // //     key: 'specifications',
  // //     title: 'specifications',
  // //     description: 'Specifications list',
  // //     fetchUrl: 'getAllSpecifications',
  // //     addUrl: 'addSpecifications',
  // //     editUrl: 'addSpecifications',
  // //     removeUrl: 'RemoveSpecifications',
  // //     options: { noAddNew: true },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'category',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/11.jpg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { col: '6', key: 'type', type: 'TextInput', information: { label: 'Type', disabled: false, required: true }, showMain: true, inExport: true },
  // //         { col: '6', key: 'title', type: 'TextInput', information: { label: 'Title', disabled: false, required: true }, showMain: true, inExport: true },
  // //         { col: '6', type: 'SelectInput', key: 'categories', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: true, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
  // //         { col: '6', key: 'values', type: 'TextInput', information: { label: '{{lang}}values', placeholder: '{{lang}}values', required: true }, showMain: true },
  // //         { col: '6', type: 'SelectInput', key: 'parent', information: { label: '{{lang}}parent', updateAfterSelect: true, isSearchable: true, address: 'getAllSpecifications', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
  // //         { col: '6', key: 'sufix', type: 'TextInput', information: { label: '{{lang}}Sufix', placeholder: '{{lang}}sufix', required: true }, showMain: true },
  // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },

  // //     ],

  // // },


  // // city: {
  // //     key: 'City',
  // //     title: 'Cities',
  // //     description: 'Cities list',
  // //     fetchUrl: 'getAllCities',
  // //     addUrl: 'addCities',
  // //     editUrl: 'addCities',
  // //     removeUrl: 'RemoveCities',
  // //     options: { noAddNew: true },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'Countries',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/11.jpg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { col: '6', key: 'name', type: 'TextInput', information: { label: 'Name', disabled: false, required: true }, showMain: true, inExport: true },
  // //         { col: '6', type: 'SelectInput', key: 'country', information: { label: '{{lang}}Countries', updateAfterSelect: true, isSearchable: true, address: 'getAllCountries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
  // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
  // //     ],

  // // },


  // // countries: {
  // //     key: 'Countries',
  // //     title: 'Countries',
  // //     description: 'Countries list',
  // //     fetchUrl: 'getAllCountries',
  // //     addUrl: 'addCountries',
  // //     editUrl: 'addCountries',
  // //     removeUrl: 'removeCountries',
  // //     options: { noAddNew: true },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'Countries',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/11.jpg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { col: '12', key: 'name', type: 'TextInput', information: { label: 'Name', disabled: false, required: true }, showMain: true, inExport: true },
  // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
  // //     ],

  // // },


  // // Permissions: {
  // //     key: 'Permissions',
  // //     title: '{{lang}}Permissions',
  // //     description: 'Permissions list',
  // //     fetchUrl: 'getPermissions',
  // //     addUrl: 'addPermission',
  // //     editUrl: 'addPermission',
  // //     removeUrl: 'removePermission',
  // //     options: { noAddNew: true },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'admin',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/11.jpg',
  // //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { col: '6', type: 'SelectInput', key: 'users', information: { label: '{{lang}}Users', updateAfterSelect: true, isSearchable: true, address: 'getUsers', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: true },
  // //         { col: '6', type: 'MultiSelectInput', key: 'permissions', information: { label: '{{lang}}Permission', type: 'local', items: [{ value: 'superadmin', title: 'super admin' }, { value: 'admin', title: 'admin' }], isSearchable: true, placeholder: '{{lang}}Permission', required: true }, showMain: true },
  // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
  // //     ],

  // // },


  // // Products: {
  // //     key: 'Products',
  // //     title: 'Products',
  // //     description: 'Products list',
  // //     fetchUrl: 'getProducts',
  // //     addUrl: 'addProduct',
  // //     editUrl: 'addProduct',
  // //     removeUrl: 'removeProduct',
  // //     options: { noAddNew: true },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'products',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/11.jpg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { col: '6', key: 'title', type: 'TextInput', information: { label: 'Title', disabled: false, required: true }, showMain: true, inExport: true },
  // //         { col: '6', type: 'SelectInput', key: 'categories', information: { label: '{{lang}}Categories', updateAfterSelect: true, isSearchable: true, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: true }, showMain: false },
  // //         { col: '6', type: 'SelectInput', key: 'status', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
  // //         { col: '6', type: 'PriceInput', key: 'price', information: { label: '{{lang}}Price', placeholder: '{{lang}}Price', required: true }, hideInfilter: true, showMain: true },
  // //         { type: 'TextInput', key: 'priceSettings.discount.type', col: '6', information: { label: '{{lang}}Discount Type', placeholder: '{{lang}}Discount Type', required: true }, showMain: true, },
  // //         { col: '6', type: 'PriceInput', key: 'priceSettings.discount.value', information: { label: '{{lang}}price discount value', placeholder: '{{lang}}price discount value', required: true }, hideInfilter: true, showMain: true },
  // //         { type: 'PriceInput', key: 'priceSettings.priceBeforeDiscount', col: '6', information: { label: '{{lang}}Price Before Discount', placeholder: '{{lang}}Price Before Discount', required: true }, showMain: true, },
  // //         { type: 'TextInput', key: 'priceSettings.currency', col: '6', information: { label: 'currency', placeholder: 'currency', required: true }, showMain: true, },
  // //         { col: '12', type: 'SelectInput', key: 'specifications', information: { label: '{{lang}}specifications', updateAfterSelect: true, isSearchable: true, address: 'getAllSpecifications', filter: { page: 'form' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}specifications', required: false }, showMain: false },
  // //         {
  // //             type: 'SubformInput',
  // //             key: 'colors',
  // //             col: '12',
  // //             information: {
  // //                 headers: [
  // //                     { type: 'TextInput', key: 'color', col: '6', information: { label: '{{lang}}Coler Label', placeholder: '{{lang}}Color Label', required: true }, showMain: true, },
  // //                     { type: 'TextInput', key: 'name', col: '6', information: { label: '{{lang}}Color Name', placeholder: '{{lang}}Color Name', required: true }, showMain: true, },
  // //                     { type: 'TextInput', key: 'hex', col: '6', information: { label: '{{lang}}Color Hex Code', placeholder: '{{lang}}Color Hex Code', required: true }, showMain: true, },
  // //                 ],
  // //                 placeholder: '{{lang}}placeholders.insertInformation',
  // //                 required: true,
  // //             },
  // //             showMain: true
  // //         },
  // //         { key: 'images', type: 'ImageInput', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
  // //         { key: 'cover', type: 'ImageInput', col: '12', information: { label: '{{lang}}cover', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
  // //         { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },

  // //     ],

  // // },




  // // questions: {
  // //     key: 'froum',
  // //     title: 'سوالات',
  // //     description: 'لیست سوالات',
  // //     fetchUrl: 'getQuestions',
  // //     addUrl: 'postQuestion',
  // //     editUrl: 'postQuestion',
  // //     removeUrl: 'removeQuestion',
  // //     options: { noAddNew: false },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'froum',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/8.jpg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { col: '6', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true } },
  // //         { col: '6', type: 'SelectInput', key: 'status', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
  // //         { col: '6', type: 'SelectInput', key: 'category', information: { label: '{{lang}}category', updateAfterSelect: true, isSearchable: true, address: 'getContents', filter: { page: 'AcademyCategories' }, fields: { title: 'values.title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
  // //         { col: '6', key: 'votes', type: 'NumberInput', information: { label: '{{lang}}votes', placeholder: '{{lang}}votes', required: false }, hideComponent: true, showMain: false },
  // //         { col: '6', key: 'answers', type: 'NumberInput', information: { label: '{{lang}}answers', placeholder: '{{lang}}answers', required: false }, hideComponent: true, },
  // //         { col: '6', key: 'views', type: 'NumberInput', information: { label: '{{lang}}views', placeholder: '{{lang}}views', required: false }, hideComponent: true, showMain: false },
  // //         { col: '6', type: 'MultiSelectInput', key: 'special', information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
  // //         {
  // //             key: 'major',
  // //             type: 'SelectInput',
  // //             col: '6',
  // //             information: {
  // //                 label: '{{lang}}رشته ها',
  // //                 placeholder: '{{lang}}insert',
  // //                 type: 'local',
  // //                 items: [
  // //                     { title: "ریاضی", value: 'ریاضی' },
  // //                     { title: 'تجربی', value: 'تجربی' },
  // //                     { title: 'انسانی', value: 'انسانی' },
  // //                 ],
  // //                 required: true

  // //             },
  // //             showMain: true
  // //         },


  // //         {
  // //             key: 'grade',
  // //             type: 'SelectInput',
  // //             col: '6',
  // //             information: {
  // //                 label: '{{lang}}مقطع تحصیلی',
  // //                 placeholder: '{{lang}}insert',
  // //                 type: 'local',
  // //                 items: [
  // //                     { title: "دهم", value: 'دهم' },
  // //                     { title: 'یازدهم', value: 'یازدهم' },
  // //                     { title: 'دوازدهم', value: 'دوازدهم' },
  // //                 ],
  // //                 required: true
  // //             },
  // //             showMain: false
  // //         },

  // //         { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}body', placeholder: '{{lang}}body', required: true }, showMain: false },
  // //     ],

  // // },


  // // messages: {
  // //     key: 'message',
  // //     title: 'all message',
  // //     description: 'we have messages here',
  // //     fetchUrl: 'getMessages',
  // //     addUrl: 'postMessage',
  // //     removeUrl: 'removeMessage',
  // //     // options: { noAddNew: true },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'messages',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/7.jpg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { col: '12', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', placeholder: '{{lang}}Title', required: true }, showMain: true },
  // //         { col: '6', type: 'SwitchInput', key: 'public', information: { label: '{{lang}}public', type: 'local', items: [{ value: 'public', title: 'public' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: false },
  // //         { col: '6', type: 'MultiSelectInput', key: 'users', information: { label: '{{lang}}Users', updateAfterSelect: true, isSearchable: true, address: 'getUsers', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
  // //         { col: '12', key: 'message', type: 'TextAreaInput', information: { label: '{{lang}}message', placeholder: '{{lang}}message', required: true }, showMain: true },
  // //     ],
  // // },



  // // contents: {
  // //     key: 'content',
  // //     title: 'contents',
  // //     description: 'contents list',
  // //     fetchUrl: 'getContents',
  // //     addUrl: 'postContent',
  // //     removeUrl: 'removeContent',
  // //     options: { noAddNew: true },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'content',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/16.jpeg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

  // //     headers: [
  // //         { col: '6', key: 'values.contentTitle', type: 'TextInput', information: { label: 'Page', disabled: false, required: false }, showMain: true, inExport: true },
  // //         { col: '6', key: 'values.title', type: 'TextInput', information: { label: 'Title', disabled: false, required: false }, showMain: true, inExport: true },
  // //         { col: '12', key: 'values.slug', type: 'TextInput', information: { label: 'Slug', disabled: false, required: false }, showMain: true, inExport: true },
  // //     ],

  // // },





  // // classroom: {
  // //     key: 'classroom',
  // //     title: 'کلاس‌ها',
  // //     description: 'لیست کلاس‌ها',
  // //     fetchUrl: 'getClassrooms',
  // //     addUrl: 'postClassroom',
  // //     removeUrl: 'removeClassroom',
  // //     options: { noAddNew: true },
  // //     pageType: 'form',
  // //     parent: 'content',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/16.jpeg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { key: 'values.image', type: 'ImageInput', col: '6', information: { label: '{{lang}}image', single: true, cropper: true, placeholder: '{{lang}}chooseImage', required: true } },
  // //         { col: '6', type: 'DateInput', key: 'chooseDate', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: true, disabled: false } },
  // //         { col: '12', key: 'title', type: 'TextInput', information: { label: 'TITLE', disabled: false, required: true }, showMain: true, inExport: true },
  // //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}DESCRIPTION', placeholder: '{{lang}}inser', required: false } },
  // //         { col: '6', key: 'family', type: 'TextInput', information: { label: 'FAMILY', required: true }, showMain: true, inExport: true },
  // //         { col: '6', key: 'name', type: 'TextInput', information: { label: 'NAME', required: true }, showMain: true, },
  // //     ],

  // // },


  // // wallpapers: {
  // //     key: 'wallpapers',
  // //     page: 'wallpapers',

  // //     title: 'بنر‌ها',
  // //     description: 'لیست بنر‌ها',
  // //     fetchUrl: 'getAllWallpaper',
  // //     addUrl: 'postWallpaper',
  // //     removeUrl: 'removeWallpaper',
  // //     options: { noAddNew: true },
  // //     pageType: 'form',
  // //     parent: 'content',
  // //     options: {},
  // //     // addNew: -1,
  // //     image: '/images/covers/16.jpeg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { key: 'values.image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, placeholder: '{{lang}}chooseImage', required: true } },
  // //         {
  // //             key: 'values.page',
  // //             type: 'SelectInput',
  // //             col: '12',
  // //             information: {
  // //                 label: '{{lang}}page',
  // //                 placeholder: '{{lang}}insert',
  // //                 type: 'local',
  // //                 items: [
  // //                     { title: "login", value: 'login' },
  // //                     { title: 'addWiki', value: 'addWiki' },
  // //                     { title: 'addThing', value: 'addThing' },
  // //                     { title: 'addApplet', value: 'addApplet' },
  // //                     { title: 'addProfile', value: 'addProfile' },

  // //                 ]
  // //             },
  // //         },
  // //     ],

  // // },


  // // test: {
  // //     key: 'test',
  // //     title: 'آزمون‌ها',
  // //     description: 'لیست آزمون‌ها',
  // //     fetchUrl: 'getAllTests',
  // //     addUrl: 'postTest',
  // //     removeUrl: 'removeTest',
  // //     options: { noAddNew: true },
  // //     pageType: 'form',
  // //     parent: 'content',
  // //     options: {},
  // //     // addNew: -1,
  // //     image: '/images/covers/16.jpeg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}DESCRIPTION', placeholder: '{{lang}}inser', required: false } },
  // //         { col: '12', type: 'DateInput', key: 'date', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: true, disabled: false } },
  // //         {
  // //             type: 'SubformInput',
  // //             key: 'links',
  // //             col: '12',
  // //             information: {
  // //                 headers: [
  // //                     { type: 'TextInput', key: 'label', col: '6', information: { label: '{{lang}}label', placeholder: '{{lang}}value', required: true }, showMain: true, },
  // //                     { type: 'TextInput', key: 'link', col: '6', information: { label: '{{lang}}link', placeholder: '{{lang}}value', required: true }, showMain: true, },
  // //                 ],
  // //                 placeholder: '{{lang}}placeholders.insertInformation',
  // //                 required: true,
  // //             }
  // //         },
  // //     ],


  // // },

  // // leitnerbox: {
  // //     key: 'leitnerbox',
  // //     title: 'لاینتر',
  // //     description: 'سوالات لایتنر',
  // //     fetchUrl: 'getAllleitners',
  // //     addUrl: 'postLeitners',
  // //     removeUrl: 'removeLeitners',
  // //     options: { noAddNew: true },
  // //     pageType: 'form',
  // //     parent: 'leitnerbox',
  // //     options: {},
  // //     // addNew: -1,
  // //     image: '/images/covers/16.jpeg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [

  // //         {
  // //             key: 'major',
  // //             type: 'SelectInput',
  // //             col: '6',
  // //             information: {
  // //                 label: '{{lang}}رشته ها',
  // //                 placeholder: '{{lang}}insert',
  // //                 type: 'local',
  // //                 items: [
  // //                     { title: "ریاضی", value: 'ریاضی' },
  // //                     { title: 'تجربی', value: 'تجربی' },
  // //                     { title: 'انسانی', value: 'انسانی' },
  // //                 ],
  // //                 required: true

  // //             },
  // //             showMain: true
  // //         },

  // //         {
  // //             key: 'course',
  // //             type: 'SelectInput',
  // //             col: '6',
  // //             information: {
  // //                 label: '{{lang}}درس ها',
  // //                 placeholder: '{{lang}}insert',
  // //                 type: 'local',
  // //                 items: [
  // //                     { title: "فیزیک", value: 'فیزیک' },
  // //                     { title: 'ریاضی', value: 'ریاضی' },
  // //                     { title: 'زیست', value: 'زیست' },
  // //                 ],
  // //                 required: true
  // //             },
  // //             showMain: true
  // //         },

  // //         {
  // //             key: 'grade',
  // //             type: 'SelectInput',
  // //             col: '12',
  // //             information: {
  // //                 label: '{{lang}}مقطع تحصیلی',
  // //                 placeholder: '{{lang}}insert',
  // //                 type: 'local',
  // //                 items: [
  // //                     { title: "دهم", value: 'دهم' },
  // //                     { title: 'یازدهم', value: 'یازدهم' },
  // //                     { title: 'دوازدهم', value: 'دوازدهم' },
  // //                 ],
  // //                 required: true
  // //             },
  // //             showMain: false
  // //         },


  // //         { col: '12', key: 'body', type: 'EditorInput', information: { label: '{{lang}}BODY', placeholder: '{{lang}}body', required: true }, showMain: false },

  // //         { col: '12', key: 'answer', type: 'EditorInput', information: { label: '{{lang}}ANSWER', placeholder: '{{lang}}ANSWER', required: true }, showMain: false },
  // //     ],
  // // },



  // // saveleitner: {
  // //     key: 'froum4',
  // //     title: 'saved leitner',
  // //     description: 'saved leitner list',
  // //     fetchUrl: 'getSaveQuestion',
  // //     addUrl: 'saveLeitners',
  // //     removeUrl: 'removeSaveQuestion',
  // //     // options: { noAddNew: true },
  // //     // helperKey: 'values',
  // //     pageType: 'form',
  // //     parent: 'leitnerbox',
  // //     options: {},
  // //     // sort: { 'cDate': -1 },
  // //     // addNew: -1,
  // //     image: '/images/covers/7.jpg',
  // //     extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
  // //     headers: [
  // //         { type: 'SelectInput', key: 'question', col: '12', information: { label: '{{lang}}Question', updateAfterSelect: true, isSearchable: true, address: 'getAllleitners', filter: {}, fields: { title: 'title', value: 'title' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.questions', required: true }, showMain: true },
  // //     ],

  // // },


}


export { adminPages, adminSections }
